export default {
    "corporate": "Företagsprogram",
    "onboarding": {
        "goal_desc": "Du tjänar %{customPoints} på att spåra din aktivitet och bonus %{customPoints} på att slutföra dina mål. Det är dags att börja! Du kan ha 3 personliga mål aktiva samtidigt.",
        "sample_task": {
            "modalActivityTitle": "3 djupa andetag",
            "rewards_featured_title": "Utvalda",
            "rewards_partners_title": "Partners",
            "header_description": "Du tjänar %{customPoints} genom att spåra din aktivitet och slutföra uppgifter, mål och utmaningar.",
            "icon_text": "Tryck på {icon} för att spåra ett djupt andetag.",
            "activityName": "djupa andetag",
            "activityUnit": "andning"
        },
        "lets_get_started": "Låt oss börja!",
        "start_description": "Du tjänar %{customPoints} genom att spåra din aktivitet och slutföra uppgifter, mål och utmaningar.",
        "complete_and_earn": "Slutför och tjäna",
        "did_it": "Jag klarade det!",
        "task_complete": "Uppgiften slutförd!",
        "breath_sample_task": "Få en snabb översikt av aktivitetsspårning",
        "track_a_sample_activity": "Spåra en provaktivitet",
        "nice": "Härligt!",
        "nice_one": "Snyggt!",
        "nice_subtext_1": "Du har tjänat %{points} %{customPoints}.",
        "nice_subtext_2": "Att tjäna %{customPoints} hjälper dig att ta dig till nästa nivå. Varje gång du går upp en nivå kommer du att tjäna %{reward_currency}, som kan lösas in för bra erbjudanden.",
        "nice_subtext_3": "Du får fler poäng när du slutför fler uppgifter, spårar aktivitet och slutför mål och utmaningar.",
        "progress_subtitle": "Dina %{customPoints} och framsteg återställs varje %{frequency}.",
        "skip_for_now": "Hoppa över tills vidare",
        "loadingText": "Häng kvar medan vi beräknar dina välbefinnandepoäng.",
        "goal_title": "Ange ett personligt mål",
        "swipe_for_more": "Dra för att se mer",
        "skip_goals": "Jag är färdig med att sätta upp mål för nu.",
        "complete_profile": "",
        "level": "Nivå",
        "finish_onboarding_action": "Vänligen slutför registrering först",
        "vital_stats": {
            "height_ft": "Längd, fot.",
            "height_in": "Längd, inches."
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "Din integritet är viktig"
        },
        "levels": {
            "title": "Prestationer och belöningar",
            "tableTitle": "Prestation"
        },
        "initialScreen": {
            "title": "Välkommen till %{programName}, %{username}!",
            "getRewarded": "Bli belönad med %{rewardName}",
            "completeAgainst": "Tävla mot dina kollegor",
            "earnPoints": "Tjäna poäng med hälsoaktiviteter",
            "levelUp": "Nå högre nivåer och lås upp märken"
        },
        "starterGoals": {
            "title": "Välj ett mål",
            "subtitle": "Starta din välbefinnanderesa med en ny hälsosam vana."
        }
    },
    "healthkit_not_available": "Det gick inte att ansluta till Apple Health. I appen Hälsa under Källor ska du se till att du har minst aktiverat behörighet för steg och har spårat minst ett steg.",
    "changeCover": "Ändra bild",
    "joiningCommunityToast": {
        "success": {
            "message": "Du har blivit medlem i %{name}",
            "title": "Gå med i community"
        }
    },
    "achievement_starts_date": "Startar: %{date}",
    "editChallenge": "Redigera %{challengeName}",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "Välj upp till 5 aktiviteter",
            "title": "Vad vill du göra?",
            "noActivityTitle": "Lägger till aktiviteter",
            "noActivityMessage": "Välj minst en aktivitet eller kategori.",
            "categoryItemDescription": "Alla aktiviteter i kategorin %{category}",
            "addActivityTitle": "Hur många %{unit} av %{activity} vill du göra per %{period}?",
            "addCategoryQuantityTitle": "Hur många %{customPoints} vill du tjäna i kategorin %{category}?",
            "subtitleCategories": "Välj en kategori. Alla aktiviteter från den kategorin kommer att bidra till målet.",
            "subtitleWithActivities": "%{num} av %{max} valda aktiviteter",
            "selectCategoryMessage": "Alla aktiviteter i kategorin kommer att väljas och de tidigare valda aktiviteterna kommer att kasseras.",
            "addActivityTitleTotal": "Hur mycket %{activity} vill du göra under %{period}?"
        },
        "inviteDepartments": {
            "title": "Bjud in avdelningar \/ division"
        },
        "inviteRegions": {
            "title": "Bjud in regioner"
        },
        "createInvitation": {
            "selectMore": "Vänligen välj minst 2 %{entity}s!"
        },
        "visibility": {
            "title": "Synlighet",
            "description": "Teamutmaningar kan hittas och förenas av alla %{programName}-användare."
        },
        "highest": {
            "name": "De flesta %{customPoints} vinner",
            "description": "Inga begränsningar, högsta %{customPoints} tar 1a plats"
        },
        "compete": {
            "individual": "Tävla som enskild individ",
            "team": "Tävla som ett lag"
        },
        "unitType": {
            "title": "Välj hur du vill slutföra ditt mål",
            "subtitle": "Välj bland aktiviteter eller en kategori"
        },
        "category": {
            "name": "Alla aktiviteter i en kategori",
            "description": "Spåra t.ex. alla aktiviteter i \"Rörelse\"",
            "title": "Välj kategori",
            "subtitle": "Från vilken kategori kommer du att spåra aktiviteter?"
        },
        "activities": {
            "name": "Utvalda aktiviteter",
            "description": "T.ex. spåra specifika aktiviteter som cykling",
            "title": "Välj aktiviteter",
            "subtitle": "Vi rekommenderar att du fokuserar på en enda aktivitet, men du kan lägga till upp till 5",
            "maxModalTitle": "Maximalt antal valda aktiviteter",
            "maxModalDescription": "Du kan lägga till högst 5 aktiviteter. Tryck på Godkänn för att fortsätta med dina 5 valda aktiviteter eller på Redigera för att göra ändringar.",
            "warningModalTitle": "Hög svårighetsgrad",
            "warningModalDescription": "Du har angett en hel del aktivitet att slutföra per period i detta mål. Är du säker på att du vill sätta upp ett så utmanande mål?",
            "requiredPoints": "krävs för att nå %{period} %{challengeType}",
            "noActivitiesModalTitle": "Lägger till aktiviteter",
            "noActivitiesModalDescription": "Vänligen välj minst en aktivitet."
        },
        "categoryQuantity": {
            "title": "Sätt ditt mål på %{customPoints}",
            "subtitle": "Hur många %{customPoints} vill du tjäna från %{category} varje %{period}?",
            "subtitleTotal": "Hur många %{customPoints} vill du tjäna från %{category} %{period}?",
            "text": "Som riktlinje motsvarar 30 minuters måttlig aktivitet cirka 105 %{customPoints}",
            "noQuantityModalTitle": "Antal",
            "noQuantityModalDescription": "Ange ett värde",
            "defaultCategoryTitle": "nuvarande kategori"
        },
        "cancel": {
            "title": "Avbryt skapande av denna utmaning",
            "message": "Är du säker på att du vill avbryta skapandet av denna utmaning?"
        },
        "createNew": "Skapa en ny utmaning",
        "chooseChallengeTitle": "Välj en utmaning eller skapa din egen",
        "createOwn": {
            "title": "Skapa min egen"
        },
        "frequency": {
            "title": "Hur ofta kommer du att uppnå ditt mål?",
            "subtitle": "Dagliga mål är bra för att bygga vanor"
        },
        "startAndDuration": {
            "title": "Välj startdatum och varaktighet",
            "subtitle": "",
            "noFieldsTitle": "Startdatum och varaktighet",
            "noFieldsMessage": "Vänligen fyll i startdatum och varaktighet"
        },
        "finalize": {
            "title": "Granska ditt nya mål",
            "subtitle": "",
            "noFieldsTitle": "Namn och instruktioner",
            "noFieldsMessage": "Vänligen fyll i namn och instruktioner",
            "name": "Mitt %{frequency} %{names} mål",
            "instructionCategory": "Tjäna %{points} %{customPoints} %{frequency} på alla %{category} aktiviteter",
            "instructionActivities": "Spåra %{items} %{frequency} och tjäna %{points} %{customPoints} %{pointsFrequency}",
            "instructionCompetitionCategory": "Få mesta möjliga %{customPoints} från alla %{category} aktiviteter för att vinna denna tävling",
            "instructionCompetitionActivities": "Få mesta möjliga %{customPoints} från %{items} för att vinna denna tävling",
            "namePlaceholder": "Namnge din tävling",
            "titleChallenge": "Slutför din utmaning"
        },
        "dailyDescription": "T.ex. Drick 8 glas vatten varje dag",
        "weeklyDescription": "T.ex. Gå 150 minuter varje vecka",
        "monthlyDescription": "T.ex. Spring 150 km varje månad",
        "totalDescription": "T.ex. Cykla totalt 10 000 km",
        "title": "Utmana dig själv eller andra?",
        "navigatorTitle": "Skapa en utmaning",
        "me": {
            "name": "Bara jag själv",
            "description": "Utmana dig själv med ett personligt mål"
        },
        "others": {
            "name": "Tävla med andra",
            "description": "Tävla individuellt eller som ett lag"
        },
        "one": {
            "name": "Individuellt",
            "description": "Tävla individuellt med andra användare"
        },
        "team": {
            "name": "Som ett lag",
            "description": "Tävla som ett team med andra lag"
        },
        "company": {
            "name": "Företagsutmaning",
            "description": "Skapa specialtävling"
        },
        "adminItemTitle": "Som administratör kan du skapa",
        "userOrTeamTitle": "Tävla individuellt eller som ett lag?",
        "target": {
            "name": "Ange ett mål att nå",
            "description": "Utmaning som har en övre gräns"
        },
        "typeTitle": "Välj en %{challengeType} -typ",
        "teamSizeTitle": "Välj en storlek för varje lag",
        "teamSizeSubtitle": "Den minsta storleken på ett team är %{min} och den högsta är %{max}. Ditt teams %{customPoints} är genomsnittet för alla medlemmar i laget och du kan endast tjäna %{customPoints} när ditt team har uppfyllt minimiantalet medlemmar.",
        "teamSize": {
            "noFieldsTitle": "Minimum och maximum",
            "noFieldsMessage": "Välj det lägsta och högsta antalet medlemmar i ett lag"
        },
        "companyChallengeTitle": "Företagsutmaning",
        "companyChallengeSubtitle": "Du är administratör. Du kan ställa in avdelningsutmaningar och andra typer av utmaningar",
        "chooseDepartmentTitle": "Välj avdelningar \/ divisioner att tävla i",
        "chooseRegionTitle": "Välj regioner att tävla i",
        "goToChallenge": "Gå till min utmaning",
        "additional": {
            "title": "Utmaning skapad",
            "subtitle": "Låt oss börja! Bjud in andra att gå med.",
            "makePublicName": "Offentliggör detta",
            "makePublicDescription": "Vem som helst kan gå med",
            "toDirectoryName": "Skicka till utmaningskatalogen",
            "toDirectoryDescription": "Människor kan skapa en på det här sättet",
            "inviteTitle": "Bjud in till utmaning",
            "titleGoal": "Mål skapat!"
        },
        "quantityMinimum": {
            "message": "Den minsta kvantitet som krävs är %{quantity}",
            "title": "Otillräcklig Kvantitet"
        },
        "toast": {
            "success": "Din %{challengeType} har skapats."
        },
        "goToGoal": "Gå till mitt mål",
        "navigatorTitleGoal": "Skapa ett mål",
        "quantityError": {
            "wholeNumber": "Måste vara ett heltal",
            "greaterThanZero": "Måste vara större än 0"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "Din välbefinnandepoäng beräknas genom att jämföra svaren du gav i välbefinnandeundersökningen med svaren från miljontals andra människor i samma ålder och könskategori som du. Din poäng visar var du rankas i förhållande till dem. Din poäng uppdateras automatiskt varje månad beroende på hur du rör dig, äter och känner beteenden som anges i appen. Konsekvent målsättning och vidta positiva åtgärder för att förbättra din hälsa kan bidra till att öka ditt välbefinnande poäng.",
            "excellent": "Din hälsopoäng är bättre än 85 % av människor med din ålder och kön. ",
            "very_good": "Din hälsopoäng är bättre än 70-84 % av människor med din ålder och kön.",
            "good": "Din hälsopoäng är bättre än 51-69 % av människor med din ålder och kön.",
            "fair": "Din hälsopoäng är bättre än 31-50 % av människor med din ålder och kön.",
            "poor": "Din hälsopoäng är lägre än 70 % av människor med din ålder och kön. Det är aldrig för sent att börja prioritera din hälsa. Dra nytta av vår plattform för att hjälpa dig att göra framsteg på din wellnessresa!",
            "overall_result": "Sammantaget är dina välbefinnandepoäng %{status}.",
            "category_result": "Sammantaget är din {category} poäng {string}.",
            "goals": "Du kan inte vinna utan mål. Ställ in upp till 3 personliga mål och spåra för att nå dem. Med tiden när du gör livsstilsförändringar kommer du att se dina poäng stiga."
        },
        "reminder": {
            "title": "Det är dags att uppdatera din välbefinnandeundersökning!",
            "updateAnswers": "Uppdatera mina svar"
        },
        "lastUpdated": "Senast uppdaterad %{date}",
        "scoreDescription": {
            "part1": "Ditt resultat är",
            "part2": "ett resultat på",
            "belowAverage": "under genomsnittet",
            "aboveAverage": "över genomsnittet",
            "part3": "för andra din ålder och ditt kön."
        },
        "improveScore": {
            "description": "Dina poäng beräknas utifrån dina svar på enkäten om välbefinnande och din spårade aktivitet. Du kan uppdatera dina enkätsvar eller sätta upp nya mål för att bli ännu bättre.",
            "desc1": "Dina poäng kan inte bli mycket högre! För att hålla dina rutiner intressanta, utmana dig själv med mål strax utanför din normala förmåga, och bjud in andra att konkurrera med dig för att hålla motivationen uppe.",
            "desc2": "Om du är redo att nå nästa nivå, är det dags att öka utmaningen. Utmana dig själv med mål strax utanför din normala förmåga, och bjud in andra att konkurrera med dig för att hålla motivationen uppe.",
            "desc3": "Sätt personliga mål och skapa offentliga utmaningar för att hålla dig ansvarig och hålla motivationen uppe. Var noga med att välja uppnåeliga mål och korta tidsramar – vi rekommenderar 1 vecka.",
            "desc4": "Det är viktigt att vara aktiv varje dag. Om du inte har mycket rörelse i din dagliga rutin, börja med små mål som matchar dina förmågor och intressen. Var noga med att välja uppnåeliga mål och korta tidsramar – vi rekommenderar 1 vecka."
        },
        "recommendedGoals": "Rekommenderade mål",
        "recommendedDescription": {
            "desc1": "Ställ in på ",
            "desc2": "3 mål ",
            "desc3": "att fokusera på att förbättra ditt välbefinnande. Du har för närvarande "
        },
        "categoryScore": "Dina %{category} poäng är ",
        "learnMore": "Lär dig mer",
        "youAreSet": "Du är redo!",
        "goalSetting": "Sätt upp mål",
        "attention": "%{category} poäng är inte tillgängligt.",
        "move": {
            "error": "Baserat på dina svar är dina rörelsepoäng inte tillgängliga. "
        },
        "eat": {
            "error": "Du angav att sjukvårdspersonal har berättat för dig att du har typ 2-diabetes och att det är obehandlat. "
        },
        "feel": {
            "error": "Baserat på dina svar är dina känslopoäng inte tillgängliga. "
        },
        "survey": {
            "requiredField": "* det här fältet krävs"
        },
        "score_info_title": "Vad mina poäng betyder",
        "company_average_info": "Genomsnitt på mitt företag",
        "demographic_average_info": "Genomsnitt i min demografi",
        "score": "Välbefinnandepoäng",
        "table": {
            "what_it_means": "Vad det innebär",
            "score": "Poäng"
        },
        "updated": "Uppdaterad",
        "label": {
            "excellent": "Utmärkt",
            "very_good": "Mycket bra",
            "good": "Bra",
            "fair": "Tillfredsställande",
            "poor": "Dåligt"
        },
        "activity": {
            "eat": "Äta-aktivitet 1, Äta-aktivitet 2, Äta-aktivitet 3",
            "move": "Rörelse-aktivitet 1, Rörelse-aktivitet 2, Rörelse-aktivitet 3",
            "feel": "Känna-aktivitet 1, Känna-aktivitet 2, Känna-aktivitet 3"
        },
        "score_info_screen": "Hur beräknas mina poäng?",
        "details": "Detaljer",
        "activities": "Aktiviteter",
        "improveCategoryScore": "Förbättra mina %{category} poäng",
        "meaning": {
            "heading": "Poängberäkning"
        },
        "score_button": {
            "meaning": "Vad betyder den här poängen?"
        },
        "improve": "Se rekommenderade mål",
        "score_text": {
            "demographic": "Medelpoängen för din ålder och ditt kön är",
            "company": "och den genomsnittliga poängen på ditt företag är"
        },
        "scoreHigher": "högre än genomsnittet av",
        "scoreLower": "lägre än genomsnittet av",
        "settedGoals": {
            "noGoals": "Inga mål uppsatta",
            "one": "1 mål uppsatt",
            "n": "%{count} mål satta"
        },
        "yourScoreIsPoor": "Dina %{category}-poäng är dåliga",
        "unlock": {
            "title": "Lås upp dina välbefinnandepoäng",
            "description": "Fyll i ett kort frågeformulär för att ta reda på hur din allmänna hälsa är jämfört med andra personer i din demografi."
        },
        "browseAndSet": "Du kan bläddra och ställa in nya mål när dina nuvarande är klara.",
        "excellent": {
            "desc1": "Exceptionellt hälsosam livsstil",
            "desc2": "Mycket låg hälsorisk"
        },
        "veryGood": {
            "desc1": "Hälsosam livsstil",
            "desc2": "Låg hälsorisk"
        },
        "good": {
            "desc1": "Hälsosam livsstil",
            "desc2": "Genomsnittlig hälsorisk"
        },
        "fair": {
            "desc1": "Något hälsosam livsstil",
            "desc2": "Över genomsnittlig hälsorisk"
        },
        "poor": {
            "desc1": "Hög hälsorisk",
            "desc2": "Mer daglig rörelse rekommenderas",
            "desc3": "Mer daglig rörelse behövs"
        },
        "calculateScore": {
            "description": "När du slutför undersökningen om välbefinnande analyseras dina svar med hjälp av miljarder datavariabler från personer i din ålder och med samma kön. Beräkningen tar också hänsyn till den aktivitet du spårar i %{programName}.\n\nDina välbefinnandepoäng uppdateras regelbundet så att du kan se hur det förändras över tid."
        },
        "improveYourScore": "Förbättra dina poäng"
    },
    "challengerCount": "%{num} utmanare",
    "team_name": "Teamets namn",
    "syncingDeviceToast": {
        "danger": {
            "message": "Vi hade problem med att synkronisera %{name}. Vänligen försök igen.",
            "title": "Synkronisera"
        },
        "success": {
            "title": "Synkronisera",
            "message": "Synkroniseringen av %{name} lyckades. Dina aktiviteter är nu uppdaterade."
        }
    },
    "allCompanyMembers": "Alla företagsmedlemmar",
    "allCompanyMembersTeam": "Alla företagsmedlemmar (team)",
    "successfullyRedeemedItemForConfirmation": "Du har löst in detta objekt och ett bekräftelsemeddelande har skickats till %{email}.",
    "no_all_events_placeholder": "Det verkar som om det inte finns några evenemang tillgängliga att delta i just nu. Varför inte skapa ett själv?",
    "confirmDeleteAccount": "Bekräfta radering genom att ange den e-postadress som är kopplad till ditt konto",
    "deleteAccount": "Radera konto",
    "linkAccounts": "Hantera länkade konton",
    "titleSlug": {
        "icon_reward_text": "Det är lätt för berättigade medlemmar att tjäna fler poäng genom att handla med våra partners, eller på en check-up på en Members’ Choice Advantage-tandläkare med hjälp av deras extra skydd.",
        "icon_move_text": "Att spåra vardagliga hälsosamma val som att sova bättre eller äta grönsaker kan ge dig Lev bättre-poäng.",
        "icon_redeem_text": "Lev bättre belönar Medibank-medlemmar som har sjukhus- eller extraskydd för att ta hand om sin hälsa. ",
        "icon_phone_text": "Registrera dig och var på väg att lösa in belöningar, som presentkort för hälsa och välbefinnande eller spara på ditt sjukförsäkringsskydd. ",
        "wellness": "Välkommen till en värld full av välbefinnande",
        "goals": "Uppnå dina mål",
        "devices": "Håll dig på rätt spår",
        "challenges": "Skapa utmaningar",
        "celebrate": "Socialt välbefinnande",
        "habits": "Bygg hälsosamma vanor",
        "joinChallenge": "Delta i utmaningen",
        "getSocial": "Håll dig social",
        "reward": "Bli belönad för att du lever ett hälsosammare liv.",
        "move": "Rör dig, ät & må bättre.",
        "phone": "Lev bättre, må bättre."
    },
    "viewProgress": {
        "goal": "Visa målframsteg",
        "challenge": "Visa utmaningsframsteg",
        "progress": "Visa framsteg"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "Att ange denna information är valfritt, för din egen skull, och privat för dig."
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "%{potentialBonusPoints} bonus %{customPoints} är tillgänglig för detta evenemang!"
        },
        "modal": {
            "paragraph1": "Genom att delta i detta evenemang får du en bonus på %{pointsName}.",
            "paragraph2": "Alla bonusar %{pointsName} tilldelas efter att evenemanget har slutförts. Du kommer inte att få bonuspoäng för evenemang som du inte deltar i."
        }
    },
    "EAP": {
        "contactInfo": "Kontaktinformation",
        "doLater": "Jag gör det senare",
        "tellMore": "Berätta mer",
        "contactMe": "Kontakta mig",
        "title": "Medarbetar- & familjeassistansprogram",
        "reachGoal": {
            "title": "Hjälp finns tillgänglig",
            "description": "Ditt assistansprogram för anställda och familjer (EFAP), som tillhandahålls av %{providerName}, erbjuder en mängd olika hälsocoachningstjänster för att hjälpa dig att uppnå dina välbefinnandemål.\n\nVill du att %{providerName} ska kontakta dig med mer information?"
        },
        "privacyPolicy": "%{provider} Sekretesspolicy"
    },
    "HRIS": {
        "disclaimer": "Denna information ställs in automatiskt och kan inte ändras"
    },
    "settingGoals": {
        "description": "Genom att fokusera på 3 rekommenderade mål i taget kommer din sannolikhet för framgång att öka.",
        "title": {
            "one": "Du har satt upp 1 mål"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "Kontot är redan länkat till en annan användare",
            "lastAccountMessage": "Är du säker på att du vill ta bort ditt senast länkade konto? När det är borttaget måste du logga in med e-postadressen %{email} och ett nytt lösenord.",
            "unlinkCorpAccountMessage": "Är du säker på att du vill ta bort ditt företagslänkade konto? När det är borttaget måste du logga in med e-postadressen %{email} igen.",
            "alreadyLinked": "Kontot är redan länkat",
            "unlinkMessage": "Är du säker på att du vill ta bort ett länkat konto?"
        },
        "sso": {
            "emailNotVerified": "Din e-post är inte verifierad."
        },
        "signIn": {
            "dontHaveAccount": "Har du inget konto?",
            "enterPIN": "Ange ditt företags programidentifieringsnummer",
            "dontKnowPIN": "Vet du inte din PIN-kod?",
            "pin": "PIN",
            "register": "Registrera",
            "pinDescription": "Kontakta din administratör om du är osäker på din organisations unika programidentifieringsnummer (PIN-kod). Om du har en PIN-kod och har problem med att gå vidare till nästa steg, vänligen kontakta support@sproutatwork.com.",
            "keepMeTooltip": "För din bekvämlighet, när denna ruta är markerad kommer din session att förbli giltig i 30 dagar. På delade enheter rekommenderar vi att du avmarkerar den här rutan och loggar ut när du är klar."
        },
        "signUp": {
            "backToLogin": "Tillbaka till inloggningen",
            "termsOfService": "Användarvillkor",
            "privacyPolicy": "Sekretesspolicy"
        },
        "createYourAccount": "Skapa ditt konto",
        "setYourDetails": "Ange dina uppgifter",
        "ModaHybridLogin": {
            "noAccessDashboard": "Har du inte tillgång till medlemsöversikten?",
            "signUpSSOButton": "Registrera dig via Moda Member Dashboard",
            "noAccessDashboardWeb": "Om du inte har tillgång till medlemspanelen, logga in med din e-postadress och ditt lösenord nedan.",
            "loginSSOButton": "Logga in via Moda Member Dashboard"
        }
    },
    "entityHasBeenDeleted": "%{name} har tagits bort",
    "track_challenge": {
        "message": {
            "manually": "Spåra manuellt",
            "automatically": "Spåras automatiskt med %{appOrDeviceName}",
            "manuallyOrConnect": "Spåra manuellt eller anslut en app eller enhet",
            "manuallyAndBy": "Spåra manuellt och automatiskt med %{appOrDeviceName}",
            "reconnectDevice": "Enhet krävs. Vänligen anslut enheten igen",
            "manualAndAuto": "Spåra manuellt och automatiskt",
            "trackedAutomatically": "Spåras automatiskt"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "Det gick inte att registrera dig",
            "message": "Det gick inte att hämta användaruppgifter från partnern. Vänligen försök igen senare"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "En app eller enhet krävs för detta %{goalName}.",
            "subTitle": "Vänligen anslut en app eller enhet"
        }
    },
    "descriptionSlug": {
        "wellness": "Gå med i hälsocommunityn som hjälper dig att sätta upp mål, hålla kontakt med andra och hålla dig på rätt spår.",
        "goals": "Berätta vad du jobbar mot.  Vi hjälper dig att nå dit med rekommenderade mål.",
        "devices": "Synkronisera din träningsutrustning eller logga dina aktiviteter och håll dig på rätt spår för att nå ditt välbefinnandemål.",
        "challenges": "Skapa lite vänskaplig konkurrens.  Skapa en utmaning och bjud in andra att delta i det roliga.",
        "celebrate": "Håll kontakten med kollegor och fira era framgångar tillsammans.",
        "habits": "Spåra hälsoaktiviteter för att tjäna poäng. Länka din telefon eller bärbara enhet för att tjäna poäng snabbare.",
        "joinChallenge": "Se hur du jämför dig med dina medarbetare i vänskapliga tävlingar.",
        "getSocial": "Håll kontakten med kollegor och fira era framgångar tillsammans.",
        "reward_text": "Tjäna poäng för att slutföra dagliga aktiviteter och personliga utmaningar.",
        "move_text": "Oavsett om det är en promenad runt kvarteret, fem minuter av mindfulness eller en rutin med hälsosam mat, kommer du att belönas.",
        "phone_text": "Använd dina poäng för rabatter på ditt omslag och bra erbjudanden, valet är ditt.",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "Funktionen är inte aktiverad",
        "checkAppVersion": {
            "message": "Det verkar som att din app är föråldrad. Vänligen installera den senaste uppdateringen.",
            "button": "Uppdatera %{appName}"
        },
        "noConnection": {
            "title": "Ingen nätverksanslutning",
            "description": "Det ser ut som att du inte är ansluten till internet. Du kommer inte att kunna använda programmet till fullo om du inte har en anslutning.",
            "button": "Försök igen"
        },
        "uploadPhotoText": "Lägg till ett foto för din %{entityType}",
        "entities": {
            "community": "community",
            "event": "evenemang",
            "team": "lag",
            "goal": "mål",
            "challenge": "utmaning",
            "competition": "tävling"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "Det gick inte att logga in",
            "resetPasswordHeading": "Lösenordsåterställning krävs"
        },
        "signup": {
            "corporateOrOther": "Inte en Medibank-medlem? Eller en del av ett företagsprogram?",
            "sign_up_here": "Registrera dig här ",
            "errorHeading": "Det gick inte att registrera dig",
            "areYouMedibankMember": "Är du en Medibank-medlem?",
            "isMedibankMember": "Jag är medlem",
            "isNotMedibankMember": "Jag är inte medlem"
        },
        "bpidExists": "Den angivna e-postadressen är redan associerad med en må-bättre användare, e-postadressen måste vara unik.",
        "generalError": "Tjänsten för närvarande inte tillgänglig"
    },
    "rewardsNoAvailableProducts": "Det finns inga tillgängliga produkter för tillfället.",
    "endedGoal": {
        "timeToTrack": {
            "yes": "Du har fortfarande tid att spåra!",
            "no": "Din %{type} har avslutats"
        },
        "grace": "Din %{type} kan ha avslutats, men du har %{n} %{text} för att spåra glömd aktivitet",
        "notGrace": {
            "goal": "Grattis till att ha slutfört ditt mål! Fortsätt ditt fantastiska arbete genom att sätta upp ett nytt mål för att hålla ditt välbefinnande på rätt spår.",
            "competition": "Grattis till att ha slutfört utmaningen! Behåll din drivkraft genom att gå med i en annan utmaning, eller genom att skapa din egen."
        }
    },
    "appDeviceModal": {
        "defaultMessage": "Anslut enheten eller appen och spåra din utveckling på ett sömlöst sätt. Din autentisering tillåter vår teknikpartner \"Sprout\" att säkert överföra din data från ditt %{appDeviceTitle} -konto."
    },
    "noTransactionsMessage": "Det verkar som att du inte har gjort några transaktioner.",
    "noRedemptionsMessage": "Det verkar som att du ännu inte har gjort några inlösningar.",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "Du kan delta i utmaningar som enskild individ, eller som ett team",
            "prompt": "Det finns inga utmaningar att gå med i just nu. Varför inte skapa ett själv?"
        },
        "createChallengeButton": "Skapa en utmaning"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "Evenemang kan vara enligt inbjudan eller öppna för vem som helst.",
            "button": "Skapa ett evenemang"
        },
        "emptyEventsMessage": "Det finns inga evenemang att delta i just nu. Varför inte skapa ett själv?"
    },
    "appnameLiveBetter": "Lev ett bättre liv",
    "appnameTelus": "Välbefinnande",
    "appnameUPnGo": "UPnGO",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "Du har inte satt upp några mål!",
            "descriptionNoSet": "Förbättra ditt välbefinnande genom att sätta upp några mål. Kom igång snabbt med ett rekommenderat mål, välj från katalogen eller skapa ditt eget.",
            "descriptionSet": "Du kan ställa in ett av de rekommenderade målen vi har skapat bara för dig, bläddra i hela katalogen eller skapa ditt eget mål.",
            "action_text": "Sätt ett nytt mål",
            "heading_singular": "Du kan ange ytterligare 1 mål",
            "heading_plural": "Du kan ange %{number} fler mål"
        },
        "heading": "Personliga mål",
        "single": "Personligt mål"
    },
    "settingGoal": {
        "yourGoal": "Dina %{units}",
        "yourGoalDescription": "Du är på väg! Följande %{units} kommer att anges och kommer att börja direkt.",
        "selectedGoals": "Valda mål",
        "recommendedDescription": {
            "maximumSet": "Du har satt upp det maximala antalet mål. Du kan bläddra och ställa in nya mål när dina nuvarande är klara.",
            "maximumSetTitle": "Du har satt upp %{count} mål"
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "Aktiviteten har tagits bort",
            "info": "Någonting gick fel. Vänligen försök igen.",
            "danger": "Någonting gick fel. Vänligen försök igen."
        },
        "plural": {
            "success": "Aktiviteter har tagits bort",
            "info": "Någonting gick fel. Vänligen försök igen.",
            "danger": "Någonting gick fel. Vänligen försök igen."
        },
        "success": "Aktiviteten har tagits bort",
        "info": "Aktiviteten togs inte bort. Vänligen försök igen.",
        "danger": "Aktiviteten togs inte bort. Vänligen försök igen."
    },
    "participants": "Deltagare",
    "members": "Medlem(mar)",
    "timeSittingInformationOld": "Riktlinjerna rekommenderar att:\n- Minimera tid som tillbringas stillasittande.\n- Bryt upp långa perioder av stillasittande så ofta som möjligt.",
    "timeSittingInformation": {
        "title": "Riktlinjerna rekommenderar att:",
        "list": "- Minimera tid som tillbringas stillasittande.\n- Bryt upp långa perioder av stillasittande så ofta som möjligt."
    },
    "activityLevelInformationOld": "Riktlinjerna rekommenderar att:\n- Vara aktiv på de flesta, helst alla, dagar i veckan.\n- Ackumulera över 150 minuter av fysisk aktivitet av måttlig intensitet varje vecka.\n- Gör muskelstärkande aktiviteter minst 2 dagar varje vecka.",
    "activityLevelInformation": {
        "title": "Riktlinjerna rekommenderar att:",
        "list": "- Vara aktiv på de flesta, helst alla, dagar i veckan.\n- Ackumulera över 150 minuter av fysisk aktivitet av måttlig intensitet varje vecka.\n- Gör muskelstärkande aktiviteter minst 2 dagar varje vecka."
    },
    "viewGuidelines": "Visa riktlinjer",
    "corporateAccountLink": {
        "verification": {
            "title": "Verifiera den e-postadress du använder i arbetet",
            "description": "Du måste verifiera den e-postadress du använder i arbetet för att kunna slutföra länkningsprocessen. Vänligen följ instruktionerna som skickats till:"
        }
    },
    "invitation": {
        "findFriendsAndFamily": "Hitta vänner & familj",
        "findFriends&Family": "Hitta vänner & familj",
        "tapToAddFriendsAndFamily": "Tryck för att lägga till i vänner & familj",
        "addedFriendsAndFamily": "Tillagd till vänner & familj",
        "whoYouAreLookingFor": "Hittar du inte den du letar efter?",
        "inviteWithEmail": "Bjud in med e-post",
        "sentInvitations": "Skickade inbjudningar",
        "foundPerson": "Vi hittade den här personen med en matchande e-postadress",
        "youAreBoth": "Ni tillhör båda %{entityName}",
        "youAreBothMore": "Ni tillhör båda %{entityName}, +%{n} till",
        "noFriendsAndFamilyAdded": "Det verkar som att du inte har några vänner eller familj tillagda ännu.",
        "sendInvitation": "Skicka inbjudan",
        "youHaveNoSentInvitations": "Du har inte skickat några inbjudningar",
        "toast": {
            "success_title": "Inbjudan skickad",
            "success_description": "%{invite_email} kommer att se din inbjudan i sin inkorg",
            "danger_title": "Inbjudan misslyckades",
            "danger_description": "Vänligen försök igen senare"
        },
        "email": {
            "invalid_email": "Vänligen ange en giltig e-postadress"
        },
        "inviteOthers": "Bjud in andra",
        "searchForSomeone": "Sök efter någon",
        "searchForOthersToInvite": "Sök efter andra att bjuda in",
        "programNameOnly": {
            "title": "Endast %{programName}",
            "description": "Denna %{entityType} är endast tillgänglig för personer som är en del av %{programName}"
        },
        "domainCannotBeUsed": "Denna domän kan inte användas med %{programName}",
        "actionSearchByEmail": "Bjud in via e-post om du inte hittar personen du letar efter",
        "send": "Skicka",
        "addEmailToList": "Lägg till e-post i listan",
        "toBeSent": "Inbjudningar att skickas",
        "noInvitationsToBeSent": "Inga inbjudningar",
        "removeEmailConfirmation": "Är du säker på att du vill ta bort detta e-postmeddelande från listan?",
        "yes": "Ja",
        "no": "Nej",
        "foundByEmail": "Vi hittade den här personen med en matchande e-postadress",
        "addToFriendsAndFamily": "Tryck för att lägga till som vänner & familj",
        "alreadyAddedEmail": "Du har redan lagt till detta e-postmeddelande i listan"
    },
    "pointsCurrencyAdditionalInfo": "Dina %{points_name} och nivåer börjar på nytt varje %{period}. Alla dina spårade aktiviteter bidrar till din samlade nivå under perioden.",
    "rankLabel": "Rankning",
    "leaderboards": {
        "loadingLabel": "Laddar topplistor... Detta kan ta några minuter - det ser ut som att alla är ute och håller sig aktiva!"
    },
    "feeds": {
        "emptyListHomePage": "Det finns inga inlägg att visa här just nu. Prova att justera flödet för att visa fler inlägg.",
        "viewingPostsFrom": "Visa inlägg från",
        "postActivity": "Lägg till en kommentar eller ett foto om dina aktiviteter!",
        "indicatorLoader": {
            "defaultTitle": "Uppdaterar...",
            "successfulLoadedTitle": "Synkroniserade & uppdaterade..."
        },
        "inapropriateTextError": {
            "message": "Innehållet i ditt meddelande kan vara olämpligt. Vänligen försök att använda ett vänligare språk."
        },
        "postImageError": {
            "title": "Tyvärr kan vi inte publicera detta",
            "message": "Den bild du har lagt till kan vara olämplig. Vänligen prova med en annan."
        }
    },
    "syncModal": {
        "connect": {
            "title": "Ansluter %{name}",
            "description": "Gör följande för att ansluta din %{name} -data till ditt konto:",
            "firstStep": "Ladda ner och installera mobilapplikationen %{appName} från %{storeName}",
            "fourthStep": "Välj för att hålla kontakt med %{name}",
            "fifthStep": "Vid förfrågan väljer du hälsostatistiken som ska synkroniseras med %{appName} och trycker sedan på \"Klar\"",
            "additionalInfo": "Observera att för att Health-appen ska synkronisera måste %{appName} öppnas. Även om du inte behöver hålla appen öppen kan det ta en timme för synkroniseringen att slutföras och visas i aktivitetsloggen."
        },
        "title": "Synkroniserar %{name}",
        "description": "Gör följande för att ansluta din %{name} -data till ditt konto:",
        "steps": {
            "one": "Logga in på din %{appName}-app på din telefon",
            "two": "Öppna sektionen Appar & enheter i din profil",
            "three": "Tryck på synkroniseringsknappen bredvid %{name}",
            "iPhone": "Logga in på din %{appName}-app på din iPhone"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "Arbetskonto",
            "message": "Kontot har anslutits"
        },
        "danger": {
            "message": "Fel vid anslutning av konto"
        },
        "conflict": {
            "message": "Kontot är redan länkat till en annan användare"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "Arbetskonto",
            "message": "Kontot har kopplats bort"
        },
        "danger": {
            "title": "Länka konton",
            "message": "Fel vid frånkoppling av konto"
        }
    },
    "earnMoreWithPartners": "Tjäna mer med partners",
    "connectPartnersToEarnByShopping": "Anslut dina konton och tjäna mer %{unit_type} genom att handla med %{program_name}-partners.",
    "viewAllPartners": "Visa alla partners",
    "myPartnerMemberships": "Mina partnermedlemskap",
    "linkAccount": "Länka medlemskap",
    "linkToPartner": "Länk till partner",
    "linkingError": "Det gick inte att länka ditt konto. Vänligen försök igen.",
    "linkPending": "Länk inväntas",
    "unlinkAccount": "Ta bort länk till konto",
    "linkedToPartnerName": "Länkad till %{partner_name}",
    "linked": "Länkad",
    "permission": {
        "facebookTitle": "Registrera dig med Facebook",
        "googleTitle": "Registrera dig med Google",
        "facebookDescription": "När du registrerar dig på Facebook måste du ge vår teknikpartner \"Sprout\" tillåtelse att komma åt din identitet och skapa ditt %{programName}-konto.",
        "googleDescription": "När du registrerar dig hos Google måste du ge vår teknikpartner \"Sprout\" tillåtelse att komma åt din identitet och skapa ditt %{programName}-konto.",
        "camera": {
            "title": "Åtkomst till kameran",
            "description": "Åtkomst till kameran krävs för att ta ett foto. I iPhone-inställningarna trycker du på %{appName} och öppnar kameran.\n\nObservera att du kan förlora eventuella ändringar som inte har sparats."
        },
        "notNow": "Inte nu",
        "openSettings": "Öppna inställningar",
        "photos": {
            "title": "Tillåt tillgång till foton",
            "description": "Detta gör att du kan dela foton från ditt bibliotek och spara foton till kamerarullen. I iPhone-inställningarna trycker du på %{appName} och ändrar Foton till Läs och skriv.\n\nObservera att du kan förlora eventuella ändringar som inte har sparats."
        }
    },
    "firstNameContainsSpecialChar": "Ditt förnamn får endast innehålla engelska bokstäver, bindestreck -, och apostrofer",
    "lastNameContainsSpecialChar": "Ditt efternamn får endast innehålla engelska bokstäver, bindestreck -, och apostrofer '",
    "goToPartnerSite": "Gå till partnerns webbplats",
    "noPartnersFound": "Inga partners hittades",
    "noLinkedPartners": "Inga länkade partners",
    "noPartnersInCategory": "Inga partners i kategorin",
    "partnerAccountPendingVerification": "Kontoverifiering pågår",
    "shopWithPartner": "Handla hos partner",
    "shopWithPartnerName": "Handla hos %{partner_name}",
    "linkToPartnerName": "Länk till %{partner_name}",
    "earnPartnerMembershipIdentifier": "Identifikation av medlemskap",
    "earnPartnerAccountPendingAddLink": "Ditt medlemskap länkas vilket kan ta flera dagar att slutföra.",
    "earnPartnerAccountPendingRemoveLink": "Ditt medlemskap håller på att kopplas bort vilket kan ta flera dagar att slutföra.",
    "linkStatusUpdating": "Uppdatering av länkstatus",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "Grattis till att ha lagt till dina första aktiviteter! \n\nOm du vill kan du lägga till fler aktiviteter för idag eller andra dagar. När du är klar med dagens aktiviteter, tryck på",
            "description2": "på nästa skärm när du inte har något mer att spåra."
        },
        "listTitle": "Aktiviteter som spåras på",
        "dots": {
            "tracked": "Dagens spårade aktiviteter",
            "added": "Aktiviteter har lagts till och väntar på inlämning"
        },
        "trackedActivitiesFor": "Spårade aktiviteter för %{date}",
        "activityTracking": "Aktivitetsberäkning",
        "addedPending": "Tillagd (väntar på inlämning)",
        "search": {
            "description1": "Tryck",
            "description2": "för att se tillgängliga aktiviteter eller söka efter en specifik aktivitet"
        },
        "addActivity": "Lägg till aktivitet",
        "addAnotherActivity": "Lägg till en annan aktivitet"
    },
    "rewardsBalance": "Saldo för %{currencyName}: %{points}",
    "membershipIdentifierRequiredError": "Din identifikation för medlemskap krävs för att länka",
    "incorrectValueInRange": "Vänligen ange ett värde mellan %{min} och %{max}",
    "joinTeam": {
        "title": "Gå med i ett lag",
        "createInsteadText": "Gå med eller skapa ett team för att delta i denna utmaning"
    },
    "teamRank": "Lagets rankning",
    "teamScore": "Lagets poäng",
    "appsDevices": {
        "infoText": "Du kommer att bli ombedd att tillåta vår teknikpartner Sprout Wellness Solutions, Inc. att komma åt data om ditt välmående när du lägger till en app eller enhet.",
        "connectModal": {
            "title": "Tillåtelse",
            "paragraph1Part1": "Du kommer att bli ombedd att tillåta vår teknikpartner",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.",
            "paragraph1Part3": "att få tillgång till data om ditt välmående.",
            "paragraph2Desc1": "Din auktorisering tillåter",
            "paragraph2Desc2": "Sprout",
            "paragraph2Desc3": "för att på ett säkert sätt synkronisera din",
            "paragraph2Desc4": "data med",
            "paragraph2Desc5": ", och hjälper dig att tjäna mer %{pointsName}!"
        },
        "statusAlert": {
            "connectMessage": "Anslut en app eller aktivitetsmätningsenhet och gör aktivitetssynkronisering och spårning lätt som en plätt",
            "connectAction": "Vänligen anslut en app eller enhet",
            "errorMessage": "Vissa av dina anslutna appar eller enheter kan inte synkroniseras",
            "warningMessage": "Vissa av dina anslutna appar eller enheter kan ha ett anslutningsproblem",
            "errorAction": "Åtgärda detta fel",
            "warningAction": "Åtgärda denna varning",
            "syncingError": "Synkroniseringsfel",
            "syncingIssue": "Synkroniseringsproblem"
        },
        "deviceDetails": {
            "warningMessage": "Den här appen eller enheten har problem med att synkronisera",
            "errorMessage": "Den här appen eller enheten kan inte synkroniseras",
            "warningAction": "Avfärda varning",
            "noActivities": "Inga %{deviceName} aktiviteter har synkroniserats med %{programName} under de senaste 7 dagarna. \n\nDet kan ta upp till en timme för aktiviteter att dyka upp här efter att de har spårats med %{deviceName}.\n\nOm du har en annan app eller enhet ansluten och fler steg har spårats av den andra appen eller enheten, kommer du att se aktiviteten där. Annars kan du försöka koppla bort och återansluta %{deviceName}. Om du blir ombedd att autentisera eller bevilja behörigheter, se till att du aktiverar aktivitetsdata och använder samma konto för att autentisera som det som används för att spåra aktiviteterna. Vänligen se stegen för felsökning för mer information.  "
        },
        "troubleshooting": "Felsökning",
        "deviceItem": {
            "error": "Anslutningsfel",
            "warning": "Anslutningsvarning",
            "unableToSync": "Kunde inte synkronisera"
        },
        "platformDevice": {
            "defaultApp": "Din enhets standardhälsoapp är",
            "continueMore": "Fortsätt till fler appar och enheter"
        }
    },
    "friendsAndFamily": {
        "learnMore": "Lär dig mer om vänner & familj",
        "learnModal": {
            "title": "Om vänner & familj",
            "description": "När du har lagt till någon som vänner och familj kan du välja att dela dina inlägg på %{programName} med endast dem.\n\nDu kan också filtrera inlägg som du ser på %{programName} till endast personerna på din vän- och familjelista om de har skrivit till alla eller till dig.",
            "description_line1": "När du har lagt till någon som vänner och familj kan du välja att dela dina inlägg på %{programName} med endast dem.",
            "description_line2": "Du kan också filtrera inlägg som du ser på %{programName} till endast personerna på din vän- och familjelista om de har skrivit till alla eller till dig.",
            "whatIconsMean": "Vad ikonerna betyder",
            "canAdd": "Lägg till",
            "added": "Tillagd"
        },
        "searchDescription1": "Sök efter personer att lägga till i dina vänner och familj.",
        "searchDescription2": "Hittar du inte den du letar efter? Bjud in dem att gå med via e-post.",
        "friends&Family": "Vänner & familj",
        "managingTour": {
            "title": "Hantera vänner & familj",
            "body": "Om du vill ta bort någon från dina vänner och din familj, tryck på ikonen"
        },
        "removeOption": "Ta bort från vänner och familj",
        "inviteDescription1": "Sök efter dina vänner och familj.",
        "inviteDescription2": "Hittar du inte personen du letar efter?"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "Inläggen du delar med endast vänner och familj kommer inte längre att vara synliga för %{userFirstName}."
        }
    },
    "skipAll": "Hoppa över alla",
    "smallMin": "min",
    "eap": {
        "skipModal": {
            "title": "Är du säker?",
            "description": "Du kan alltid kontakta Medarbetar- och familjeassistansprogrammet från din profil när du behöver det."
        },
        "contact": {
            "whatIsBestNumber": "Vilket är det bästa numret att kontakta dig på?",
            "whatIsBestTime": "Vilken är den bästa tiden att kontakta dig?",
            "morning": "Morgon",
            "afternoon": "Eftermiddag",
            "evening": "Kväll",
            "additionalDetails": "Ytterligare information om tid\/datum när du vill bli kontaktad",
            "message": "Kontakta mig på %{weekDay} på %{phoneNumber}. Ytterligare information: %{additional}",
            "description": "Notera: Vi rekommenderar starkt att du väljer en tid utanför din arbetstid och väljer en plats där du kommer att kunna ha en privat konversation. Vänligen inkludera din tidszon."
        },
        "phoneNumber": {
            "empty": "Detta fält kan inte vara tomt",
            "missingDigits": "Telefonnumret måste innehålla minst 4 siffror"
        },
        "myEAP": "Mitt assistansprogram för medarbetare och familj"
    },
    "healthSurveySkipAllTitle": "Hoppa över enkät om välbefinnande",
    "healthSurveySkipAllAlert": "Är du säker på att du vill hoppa över alla återstående frågor i undersökningen om välbefinnande?",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "Medarbetar- och familjeassistansprogram",
            "message": "Ange ditt telefonnummer och bästa kontakttid"
        }
    },
    "allMyChallenges": "Mina utmaningar",
    "invitedChallenges": "Inbjudningar",
    "companyChallenges": "Företagets utmaningar",
    "completedChallengesEmpty": "Det verkar som att du inte har slutfört några utmaningar ännu.",
    "myChallengesEmpty": "Det verkar som att du inte har gått med i några utmaningar ännu.",
    "allChallengesEmpty": "Det finns inga utmaningar.",
    "startsToday": "Börjar idag",
    "startedDaysAgo": "Började för %{dayCount} dagar sedan",
    "startsInDays": "Börjar om %{dayCount} dagar",
    "privacyOn": "Av",
    "privacyOff": "På",
    "dashboard": {
        "viewLeaderboard": "Se topplistan",
        "timePeriodProgress": "Dina framsteg denna %{period}",
        "howToEarn": "Så tjänar du poäng"
    },
    "privacyChangeConfirmationMessage": "Ändra integritetsinställningar?",
    "privacySettingsTitle": "Integritet",
    "privacySettingsDescription": "Du kan styra synligheten av din bild, ditt namn och din profil för andra användare. ",
    "mainLeaderBoardSettingsTitle": "Övergripande topplista",
    "challengeLeaderBoardSettingsTitle": "Utmaningens topplista",
    "managePrivacySettingUrlTitle": "Hantera integritetsinställningar",
    "onboardingFamilyPrivacySettingsMessageOn": "Du är synlig i sökresultat för vänner & familj. Du kan välja att dölja dig från sökresultat.",
    "onboardingFamilyPrivacySettingsMessageOff": "Dina integritetsinställningar döljer dig för närvarande i sökresultat för vänner & familj.",
    "challengeInvitationPrivacySettingsMessageOn": "Du är synlig i sökresultat för inbjudningar till utmaningar. Du kan välja att dölja dig från sökresultat.",
    "challengeInvitationPrivacySettingsMessageOff": "Dina integritetsinställningar döljer dig för närvarande från sökresultat för inbjudningar till utmaningar.",
    "challengeParticipationPrivacySettingsMessageOn": "Du är listad som deltagare i denna utmaning. Du kan välja att dölja dig som deltagare från dina utmaningar.",
    "challengeParticipationPrivacySettingsMessageOff": "Dina integritetsinställningar döljer dig för närvarande från deltagarlistan.",
    "communityInvitationPrivacySettingsMessageOn": "Du är synlig i sökresultat för inbjudningar till utmaningar. Du kan välja att dölja dig från sökresultat.",
    "communityInvitationPrivacySettingsMessageOff": "Dina integritetsinställningar döljer dig för närvarande från sökresultat för inbjudningar till utmaningar.",
    "communityParticipationPrivacySettingsMessageOn": "Du är listad som medlem i denna community. Du kan välja att dölja dig själv som medlem från dina communities.",
    "communityParticipationPrivacySettingsMessageOff": "Dina integritetsinställningar döljer dig för närvarande från deltagarlistan.",
    "eventInvitationPrivacySettingsMessageOn": "Du är synlig i sökresultat för inbjudningar till utmaningar. Du kan välja att dölja dig från sökresultat.",
    "eventInvitationPrivacySettingsMessageOff": "Dina integritetsinställningar döljer dig för närvarande i sökresultat för inbjudningar till utmaningar.",
    "eventParticipationPrivacySettingsMessageOn": "Du är listad som deltagare i detta evenemang. Du kan välja att dölja dig själv som deltagare i dina evenemang.",
    "eventParticipationPrivacySettingsMessageOff": "Dina integritetsinställningar döljer dig för närvarande från deltagarlistan.",
    "mainLeaderboardPrivacySettingsMessageOn": "Du är synlig på de övergripande topplistorna. Du kan välja att dölja dig själv, vilket kommer att ta bort din rankning, bild och namn när andra visar de övergripande topplistorna.",
    "mainLeaderboardPrivacySettingsMessageOff": "Dina sekretessinställningar döljer dig för närvarande när andra visar de övergripande topplistorna.",
    "challengeLeaderboardPrivacySettingsMessageOn": "Du är synlig på utmaningens topplista. Du kan välja att dölja dig själv, vilket kommer att ta bort din rankning, bild och namn när andra visar utmaningarnas topplistor.",
    "challengeLeaderboardPrivacySettingsMessageOff": "Dina sekretessinställningar döljer dig för närvarande när andra visar utmaningarnas topplistor.",
    "thumbsUpConfirmationTitle": "Tummen upp",
    "thumbsUpConfirmationDescriptionline1": "Grattis, du är på väg att ge din första tumme upp för att uppmuntra andra!",
    "thumbsUpConfirmationDescriptionline2": "Du kommer att inkluderas i listan över personer som gav tummen upp till detta inlägg och andra kan se din bild, namn och kan se din profil.",
    "thumbsUpConfirmationButtonOk": "Tummen upp",
    "commentToActionInfoTitle": "Vad är synligt för andra?",
    "commentToActionMessage": "När du kommenterar kan andra se din bild, ditt namn och se din profil.",
    "postToActionTitle": "Vem ser det här inlägget?",
    "postToActionMessageLine1": "När du skapar ett inlägg, kan du styra vem som kan se det och till och med posta bara för dig själv.",
    "postToActionMessageLine2": "Inläggen du delar med andra kommer att visa din bild, ditt namn och andra kan se din profil",
    "privateUsersDescriptionChallenge": "Dessa deltagare har gömt sig från listan",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n} privat",
    "privateUsersLastNamePlaceHolderChallenge": "deltagare",
    "privateUsersDescriptionEvent": "Dessa deltagare har gömt sig från listan",
    "privateUsersFirstNamePlaceHolderEvent": "%{n} privat",
    "privateUsersLastNamePlaceHolderEvent": "deltagare",
    "privateUsersDescriptionCommunity": "Dessa deltagare har gömt sig från listan",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n} privat",
    "privateUsersLastNamePlaceHolderCommunity": "medlem(mar)",
    "noPrivacySettings": "Inga integritetsinställningar",
    "linkToPartnerNameWebsite": "Länk via %{partner_name}s webbplats",
    "linkToPartnerWebsiteUrl": "Webbadress till partnerwebbplats",
    "start_end_time": "Start- och sluttid:",
    "joinCreateTeamPrivacyDisclaimer": "Din bild, ditt namn och din profil kommer alltid att vara synliga för alla när de visar ditt team i en utmaning, även om du har ändrat dina sekretessinställningar till Privat.",
    "carouselInstructions": {
        "swipe": "Dra korten för att se alla dina mål och utmaningar.",
        "click": "Klicka på korten för att se alla dina mål och utmaningar."
    },
    "achieved": "Uppnått",
    "hours": "timmar",
    "createCommunityFlow": {
        "navigatorTitle": "Skapa community",
        "stepType": {
            "title": "Communityns synlighet",
            "subTitle": "Vem kommer att kunna se och gå med i vår community?",
            "privateName": "Privat",
            "publicName": "Offentlig",
            "privateDescription": "Endast personer du bjuder in kommer att kunna se eller gå med i vår community",
            "publicDescription": "Vem som helst kan se och gå med i denna community"
        },
        "stepName": {
            "title": "Namnge din community",
            "subTitle": "Ge din community ett namn som gör att folk förstår vad den handlar om.",
            "namePlaceholder": "Namn på community",
            "noFieldsTitle": "Namn",
            "noFieldsMessage": "Inget namn angivet"
        },
        "stepDescription": {
            "title": "Om din community",
            "subTitle": "Berätta för andra vad din community handlar om.",
            "descriptionPlaceholder": "Beskrivning (valfritt)",
            "noFieldsTitle": "Beskrivning",
            "noFieldsMessage": "Ingen beskrivning har angivits"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "Lägg till ett foto"
        },
        "stepJoin": {
            "title": "Vi hittade liknande communities",
            "subTitle": "Vill du gå med i en av dessa communities istället?"
        },
        "createNew": "Skapa en ny community"
    },
    "challengeCard": {
        "allActivities": "Alla aktiviteter i",
        "category": "kategori"
    },
    "myLinkedPartners": "Mina länkade partners",
    "leaderboardPosition": "Övergripande position på topplistan",
    "remainingInChallenge": "kvarstår i utmaningen",
    "todays_progress": "Dagens framsteg",
    "this_weeks_progress": "Denna veckas framsteg",
    "this_months_progress": "Denna månads framsteg",
    "achievement": "prestation",
    "challengeCardHeader": {
        "challenge": "Utmaning",
        "recommended_personal_goals": "Rekommenderat personligt mål",
        "personal_goal": "Personligt mål",
        "competition": "Tävling",
        "recommended_goals": "Rekommenderat mål",
        "team_competition": "Lagtävling",
        "team": "Lag"
    },
    "MyMedibank": "Min Medibank",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "Sluttiden kan inte vara tidigare än starttiden",
    "company": "Företag",
    "lessThan1DayRemain": "mindre än 1 dag",
    "lessThan1HourRemain": "mindre än 1 timme",
    "remainingToday": "återstår idag",
    "periodEndsDateAndTime": "Perioden slutar %{date}, %{time}",
    "moreToGo": "%{n} mer %{unit} att gå från",
    "reachedYourGoal": "Du har nått ditt mål %{period}!",
    "reachedYourGoalToday": "Du har nått ditt mål idag!",
    "editProfileItemCorrectRange": "Ange ett giltigt värde på %{itemName} mellan det lägsta värdet %{min} och det högsta värdet %{max}",
    "invalidUrl": "Ogiltig webbadress",
    "activityLogChanged": {
        "success": "Ändringar i aktiviteten har sparats",
        "info": "Någonting gick fel... Vänligen försök igen.",
        "danger": "Någonting gick fel... Vänligen försök igen."
    },
    "discardAlert": {
        "createChallenge": "Är du säker på att du vill överge denna %{challengeType}?",
        "inviteByEmail": "Är du säker på att du vill överge ändringarna?",
        "createTeam": "Är du säker på att du vill avbryta skapandet av detta lag?",
        "cancel": "Avbryt",
        "confirm": "Ja, överge"
    },
    "entityInvalidNameError": "Namnet på %{entity} får endast innehålla siffror eller bokstäver och får inte vara tomt",
    "accept": "Acceptera",
    "sync_now": "Synkronisera nu",
    "reconnect_device": "Återanslut",
    "supported_activities": "Aktiviteter som stöds",
    "recentlySynced_activity": "Nyligen synkroniserad aktivitet",
    "noSyncedActivity_sevenDays": "Inga aktiviteter har synkroniserats under de senaste 7 dagarna",
    "recentActivityLog": {
        "convertingActivityPoints": "Synkroniserar aktiviteter...",
        "activityMinuteOrTwo": "Detta kan ta en minut eller två...",
        "noNewActivities": "Inga nya aktiviteter tillagda... Det kan ta upp till en timme innan nya aktiviteter har synkroniserats."
    },
    "deleteCommunityCheckbox": "Jag förstår att detta inte kan ångras",
    "createEvent": {
        "type": {
            "company": "Företagsevenemang",
            "user": "Användarevenemang",
            "title": "Typ av evenemang"
        },
        "privacy": "Integritet (visa deltagare eller inte)",
        "cost": "Kostnad",
        "associated": {
            "location": "Tillhörande Plats",
            "department": "Samhörande Avdelning \/ division"
        },
        "maxParticipants": "Maximum Deltagare (frivilligt)",
        "errorMessage": {
            "limit": "Kan inte vara fler än %{maxValue}",
            "negative": "Kan inte ha ett negativt värde",
            "selectedLocations": "Vänligen välj en eller flera platser"
        },
        "selectLocations": "Valda platser",
        "createNew": "Skapa ett nytt event"
    },
    "selected": "Vald",
    "deleteEventButton": "Radera detta evenemang",
    "notification": {
        "priorityNotification": {
            "title": "Du har olästa viktiga uppdateringar",
            "subtitle": "Tryck för att läsa dem nu",
            "subtitleWeb": "Klicka för att läsa dem nu"
        },
        "sectionTitle": {
            "priorityUnread": "Olästa viktiga uppdateringar",
            "all": "Alla meddelanden"
        },
        "modalTitle": "Du har %{count} viktiga uppdateringar",
        "priorityModalTitle": {
            "defaultTitle": "Visa Alla Uppdateringar"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "Avboka %{entity} %{actionType}",
            "message": "Är du säker på att du vill avbryta %{entity} %{actionType}?"
        },
        "action": {
            "creating": "skapar",
            "editing": "redigering"
        },
        "type": {
            "team": "lag",
            "community": "community",
            "event": "evenemang",
            "challenge": "utmaning",
            "goal": "mål"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "Offentliggöra det?",
            "private": "Gör det privat?"
        },
        "modalSubtitle": {
            "public": "Att göra denna %{entityType} offentlig kommer att göra den öppen för alla att upptäcka och delta i. Är du säker på att du vill offentliggöra detta %{entityType}?",
            "private": "Att göra detta %{entityType} privat kommer att göra det oåtkomligt för andra att upptäcka och delta i. Är du säker på att du vill offentliggöra detta %{entityType}?"
        },
        "footerButton": {
            "makePublic": "Ja, offentliggör",
            "makePrivate": "Ja, gör privat",
            "keepPrivate": "Håll det privat",
            "keepPublic": "Håll det offentligt"
        },
        "label": {
            "title": "Gör detta till ett offentligt %{entityType}",
            "subtitle": "Alla kan se, och vem som helst kan gå med"
        }
    },
    "imageUploader": {
        "changeImageButton": "Ändra Bild"
    },
    "copyright": "Upphovsrätt © Sprout 2019",
    "samsunghealth_not_available": "Det gick inte att ansluta till Samsung Health. I appen Hälsa under Databehörigheter ska du se till att du har åtminstone aktiverat behörighet för steg och har spårat minst 1 steg.",
    "rewardsHowDoIEarn": "Hur tjänar jag %{currencyName}?",
    "unlockAchievements": "Lås upp prestationer",
    "unlockAchievementsDescription": "Spåra aktiviteter, tjäna %{pointsName}, lås upp nivåer och tjäna mer %{currencyName}. Tryck på varje prestation för att se vad du behöver göra.",
    "myDay": "Min dag",
    "myGoalsChallengesTasks": "Mina mål, utmaningar och uppgifter",
    "yourGoalsChallenges": "Dina mål och utmaningar",
    "mySocialStream": "Communitysinlägg",
    "viewAllAchievements": "Visa alla mina prestationer",
    "viewAllBonusChallenges": "Visa alla bonusutmaningar",
    "newVersionOfAppAvailable": "Ny version tillgänglig! Vänligen ladda om sidan",
    "noBonusChallengesToDisplay": "Det finns för närvarande inga bonusutmaningar tillgängliga.",
    "bonusChallenges": "Bonusutmaningar",
    "reloadAppVersion": "Ladda om",
    "appname": "Sprout",
    "cancel_tracking_confirmation": "Är du säker på att du vill ta bort spårning av %{activity_name}?",
    "activity_tracker_instruction_header": "Tryck på en dag för att spåra aktiviteter för den dagen, eller se vad som redan har spårats.",
    "alertDashboardFunctionalityToBeAdded": "text kommer att läggas till här för att förklara vad en spårningsperiod är, likt hur det görs för flygbolagets lojalitetsprogram där användarna måste ackumulera “miles” under ett kalenderår för att få en viss status för nästa år.",
    "noNumberEntered": "Ange mängden aktivitet",
    "feed": "Flöde",
    "home": "Hem",
    "challenges": "Utmaningar",
    "explore": "Utforska",
    "rewards": "Belöningar",
    "reward": "belöning",
    "balance": "Mitt saldo för belöningar på %{programName}",
    "profile": "Profil",
    "loading": "Laddar…",
    "me": "Mig",
    "back": "Tillbaka",
    "next": "Nästa",
    "skip": "Hoppa över",
    "signup": "Registrera dig",
    "signin": "Logga in",
    "signin_maintitle": "Sprout",
    "signin_subtitle": "",
    "signinto": "Logga in för att Leva Bättre",
    "signup_with_medibank": "Registrera dig som Medibank-medlem",
    "signup_with_facebook": "Registrera dig med Facebook",
    "signup_with_google": "Registrera dig med Google",
    "signup_with_email": "Registrera dig med e-post",
    "signin_with_medibank": "Logga in med Min Medibank",
    "signin_with_facebook": "Logga in med Facebook",
    "signin_with_google": "Logga in med Google",
    "signin_with_email": "Logga in med e-postadress",
    "signup_heading": "Skapa konto",
    "not_a_medibank_member": "Inte en Medibank-medlem?",
    "keep_me_signed_in": "Håll mig inloggad",
    "forgotpassword": "Glömt ditt lösenord?",
    "emailaddress": "E-postadress",
    "password": "Lösenord",
    "enterEmailAddress": "Ange din e-postadress",
    "enterYourPassword": "Ange ditt lösenord",
    "password_for_error": "lösenord",
    "reset_password": "Återställ lösenord",
    "passwordResetSuccess": "Återställning av lösenord",
    "passwordResetEmailSent": "Om vi har ett matchande e-postmeddelande i vårt system har instruktioner för återställning av lösenord skickats till dig.",
    "loginerror": "Ett fel uppstod vid inloggning:",
    "logincancelled": "Inloggning avbruten",
    "part_of_corporate_program": "Registrerar du dig till ett företagsprogram?",
    "continue_here": "Fortsätt här",
    "program_name": "Programnamn",
    "error_provide_program_name": "Ange ett programnamn.",
    "program_not_found": "Programmet hittades inte",
    "registration_field_email": "E-postadress",
    "employeeId": "Anställnings-ID",
    "registration_field_firstName": "Förnamn",
    "registration_field_lastName": "Efternamn",
    "no_first_name": "Inget förnamn",
    "no_last_name": "Inget efternamn",
    "registration_field_password": "Nytt lösenord",
    "no_disclaimer_available": "Hoppsan, det har uppstått ett problem... Vi kunde inte hämta organisationens allmänna villkor. Vänligen försök igen senare. ",
    "registration_account_not_registered": "Det verkar som att du inte har verifierat din e-postadress ännu. Vill du att vi skickar e-postmeddelandet igen?",
    "resend_verification_email": "Verifiera e-post",
    "resend_verification_email_successful": "Vi har skickat ditt verifieringsmeddelande igen.",
    "resend_verification_email_unsuccessful": "Hoppsan, det har uppstått ett problem... Vi kunde inte skicka verifieringsmeddelandet igen. Vänligen försök igen.",
    "not_supported": "Det här inlägget kan inte visas just nu. Vänligen försök igen senare.",
    "policyAgreeError": "För att fortsätta, vänligen godkänn Användarvillkoren och Sekretesspolicyn.",
    "challenge_completion_bonus": "Slutförandebonus",
    "me_tabs": {
        "activity": "Aktivitet",
        "bookmarks": "Bokmärken"
    },
    "health_tab": {
        "my_health_score": "Dina välbefinnandepoäng",
        "overall_health_score_description": "Dina välbefinnandepoäng är",
        "health_score_explanation": "Dina välbefinnandepoäng beräknas utifrån dina svar om din hälsa och hur aktiv du är. \n\nDina poäng uppdateras varje månad baserat på dina aktivitetsnivåer. Du kan sätta och slutföra personliga mål för att förbättra dina välbefinnandepoäng.",
        "health_score_calculation_failed_onboarding": "Något gick fel och vi har inte kunnat hämta dina välbefinnandepoäng. Du kan fortsätta tills vidare och så snart problemet är löst uppdaterar vi dina poäng."
    },
    "track_activity": "Spåra aktivitet",
    "track_an_activity": "Spåra en aktivitet",
    "track": "Spåra",
    "unable_to_track": "Det går inte att spåra",
    "enter_before_track": "Ange hur mycket aktivitet som ska spåras",
    "what_to_share": "Vilken typ av uppdatering vill du dela?",
    "remove": "Ta bort",
    "activity_tracking_description": "Hur många %{units} vill du spåra?",
    "excessive_submission": "Wow! Du är på väg att spåra över 2 000 %{customPoints} för %{activity_name}. Dubbelkolla gärna att det stämmer innan du skickar in det.",
    "on": "på",
    "in": "i",
    "from": "från",
    "at": "vid",
    "no_activities": "Inga aktiviteter matchade din sökning.",
    "activity_tracking_desc": "Du måste lägga till ett nummer för att fortsätta. Tryck på X i det vänstra hörnet för att avbryta.",
    "activity_tracking_desc2": "Tryck var som helst på aktiviteten för att redigera, tryck på + för att snabbspåra målet",
    "vital_stats_title": "Om dig",
    "invalid_numeric_response": "Ogiltig",
    "invalid_numeric_response_range": "Detta nummer måste vara mellan %{minimum} och %{maximum}",
    "search_placeholder": "Sök i biblioteket...",
    "search_activities": "Sök attraktioner",
    "searching": "Söker…",
    "searchEmpty": "Inga träffar hittades",
    "vital_stats_description": "Berätta lite om dig själv",
    "health_survey_questions": "Frågor i en välbefinnandeenkät",
    "health_survey_title": "Slutför enkät om välbefinnande",
    "health_survey_results": "Resultat från enkät om välbefinnande",
    "health_survey_card_desc": "Delta i enkäten för att få en ögonblicksbild av ditt välbefinnande och sätta personliga mål.",
    "apps_devices_title": "Länka appar och enheter",
    "apps_devices_card_desc": "Synkronisera dina appar och enheter för att göra det enkelt att tjäna %{customPoints}.",
    "interests_title": "Intressen",
    "interests_card_desc": "Berätta om dina intressen. Detta hjälper oss att rekommendera mål och communities som kan vara av intresse för dig.",
    "interests_screen_desc": "Vad är du intresserad av?",
    "health_obj_title": "Mål för välbefinnande",
    "health_obj_card_desc": "Vi tycker att det är dags att sätta upp några mål. När vi väl känner till dina mål kommer vi att kunna ge dig bättre rekommendationer. Oroa dig inte, om du ändrar dig kan du enkelt göra ändringar senare i din profil. ",
    "health_obj_screen_desc": "Vilka områden vill du fokusera på?",
    "my_heatlh_obj": "Mina mål för välbefinnande",
    "health_topic_title": "Ämnen inom välbefinnande",
    "health_topic_card_desc": "Anpassa din upplevelse genom att specificera dina ämnen inom välbefinnande.",
    "health_topic_screen_desc": "Vad är du intresserad av att lära dig mer om?",
    "multi_select_check_error": "Vänligen välj minst 1 alternativ för att fortsätta",
    "my_health_topics": "Mina valda ämnen inom välbefinnande",
    "build_your_profile": "Skapa din profil",
    "personalize_title": "Anpassa",
    "personalize_desc": "Anpassa din upplevelse genom att svara på några snabba frågor.",
    "set_goals_title": "Se rekommenderade mål",
    "set_goals_desc": "Sätt personliga mål för att komma igång på din väg till bättre hälsa.",
    "set_this_goal": "Ställ in detta mål",
    "goal_set": "Mål inställt",
    "required": "Nödvändig",
    "apps_devices_description": "Anslut till en fitnessplattform för att tjäna mer %{customPoints} automatiskt.",
    "connected": "Ansluten",
    "num_connected": "%{numDevices} ansluten",
    "available": "Tillgänglig",
    "inProgress": "Pågår...",
    "time_a_m": "morgonen",
    "time_p_m": "eftermiddagen",
    "last_synced": "Senast synkroniserad",
    "last_synced_lc": "senast synkroniserad",
    "no_connected_devices": "Inga anslutna enheter",
    "apps_devices_confirm_disconnect": "Är du säker på att du vill koppla från",
    "button_delete": "Ta bort",
    "button_disconnect": "Koppla från",
    "button_cancel": "Avbryt",
    "button_dismiss": "Avfärda",
    "ok": "OK",
    "waist_helper_text": "Ditt midjemått ska tas under revbenen, vanligtvis på navelnivå, och när du står upp. Om du är osäker, använd din jeansstorlek.",
    "apps_devices_manage": "Hantera mina appar och enheter",
    "my_apps_devices": "Mina appar och enheter",
    "completeRegistration": "Slutför din registrering",
    "havingTrouble": "Har du problem?",
    "contactUs": "Kontakta support@sproutatwork.com för assistans",
    "done": "Klar",
    "brand": "Sprout",
    "cannotTrackTitle": "Det går inte att spåra aktivitet",
    "cannotTrackPrior": "Hallå där. Aktiviteter kan endast spåras efter startdatumet.",
    "cannotTrackFuture": "Inte så fort. Aktiviteter kan endast spåras fram till dagens datum.",
    "cannotTrack": "Aktiviteter kan inte spåras före ett startdatum eller för en dag i framtiden.",
    "disclaimer": "Friskrivningsklausul",
    "acceptTerms": "Jag accepterar användarvillkoren",
    "verificationEmailTitle": "Verifiera din e-postadress",
    "email_not_yet_verified": "Det verkar som att du inte har verifierat din e-postadress ännu. ",
    "email_successfully_verified_title": "Välkommen",
    "email_successfully_verified": "Du har verifierat din e-post",
    "pleaseVerifyEmailMessage1": "Du måste verifiera din e-postadress för att kunna fortsätta.",
    "pleaseVerifyEmailMessage2": "Vänligen följ instruktionerna som skickats till:",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "Skicka e-post igen",
    "restart": "Tillbaka till inloggningen",
    "firstName": "Förnamn",
    "firstNamePlaceholder": "Ditt förnamn",
    "lastName": "Efternamn",
    "lastNamePlaceholder": "Ditt efternamn",
    "email": "E-postadress",
    "emailPlaceholder": "Din e-postadress",
    "employeId": "Anställnings-ID",
    "employeIdPlaceholder": "Anställnings-ID hos företaget",
    "passwordPlaceholder": "Nytt lösenord",
    "datePickerTitle": "Välj din födelsedatum",
    "datePickerConfirm": "Bekräfta",
    "datePickerCancel": "Avbryt",
    "termsOfUsePrivacyPreLinks": "Jag godkänner",
    "sendMePromoCommunications": "Skicka reklamkommunikation till mig",
    "sendMePromoCommunicationsFromPartners": "Skicka reklamkommunikation till mig från partners",
    "termsOfService": "användarvillkor",
    "legal": "Juridisk information",
    "privacyPolicy": "sekretesspolicy",
    "and": "och",
    "programDomainLabel": "Programnamn",
    "programDomainPlaceholder": "Programnamn",
    "findProgramName": "Hitta mitt programnamn",
    "findProgramNameButton": "Hitta programnamn",
    "findProgramNameTitle": "Hitta mitt programnamn",
    "findProgramNameDescription": "Företagets e-postadress",
    "findProgramNamePlaceholder": "E-postadress",
    "findProgramSuccessMessage": "Resultatet av sökningen på programnamn har skickats till dig via e-post.",
    "findProgramSuccessTitle": "Programnamn",
    "findProgramErrorTitle": "Programnamn",
    "findProgramErrorMessage": "Hoppsan, det har uppstått ett problem... Vi stötte på ett fel när vi försökte hämta ditt programnamn. Vänligen försök igen.",
    "countryLabel": "Välj land",
    "countryName": "Land",
    "regionLabel": "Välj region",
    "regionName": "Område",
    "cityLabel": "Välj stad",
    "cityName": "Stad",
    "locationWorkLabel": "Välj plats",
    "locationWorkName": "Plats",
    "locationLabel": "Välj plats",
    "locationName": "Plats",
    "departmentLabel": "Välj avdelning \/ division",
    "departmentName": "Avdelning \/ division",
    "no_department": "Ingen avdelning \/ division",
    "enterPIN": "Vänligen fyll i ditt företags PIN",
    "verifyEmailTitle": "Verifiera e-post",
    "verifyEmailMsg": "Det verkar som att du inte har verifierat din e-postadress ännu",
    "resendEmailTitle": "Verifiera e-post",
    "resendEmailMsg": "Skickat igen till %{userEmail}",
    "select_date": "Välj ett datum",
    "changePasswordTitle": "Ändra lösenord",
    "currentPassword": "Nuvarande lösenord",
    "newPassword": "Nytt lösenord",
    "confirmNewPassword": "Bekräfta nytt lösenord",
    "passwordChangeError": {
        "currentPasswordMissing": "Vänligen fyll i ditt nuvarande lösenord",
        "newPasswordMissing": "Ange ditt nya lösenord",
        "confirmPasswordMissing": "Bekräfta ditt nya lösenord",
        "passwordsMatch": "Lösenorden stämmer inte överens",
        "passwordIncorrect": "Felaktigt lösenord. Vänligen försök igen."
    },
    "settings": "Inställningar",
    "signOut": "Logga ut",
    "updateApp": "Uppdatera app",
    "updateAppRight": "Aktuell: %{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "",
    "playStoreUrlTelus": "",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "Få hjälp",
    "feedback": "Feedback",
    "feedback_success_title": "Återkoppling skickad",
    "feedback_success_msg": "Tack för din återkoppling, vi uppskattar den verkligen!",
    "feedback_failure_title": "Ett fel uppstod",
    "feedback_failure_msg": "Vilken besvikelse... Ett fel uppstod när din feedback skulle skickas in, vänligen försök igen.",
    "submit": "Skicka in",
    "feedback_char_limit": "Du har överskridit teckengränsen.",
    "feedback_char_limit_toast_title": "För långt meddelande",
    "feedback_char_limit_toast_msg": "Ditt meddelande överskrider den maximala gränsen på 2000 tecken.",
    "feedback_char_length_msg_1": "Du har skrivit",
    "feedback_char_length_msg_2": "\/2000 tecken.",
    "feedback_empty_toast_title": "Meddelande tomt",
    "feedback_empty_toast_msg": "Det verkar som att du inte har skrivit något än. Skriv ett meddelande innan du skickar in.",
    "feedback_email_message": "Meddelande:",
    "feedback_email_user_id": ", Användar-ID:",
    "feedback_email_device": ", Enhet:",
    "feedback_email_os_version": ", OS-Version:",
    "feedback_email_app_version": ", App-version:",
    "savingUserToast": {
        "success": {
            "title": "Spara ändringar",
            "message": "Profiländringar sparade"
        },
        "danger": {
            "title": "Ett fel uppstod",
            "message": "Hoppsan... Ett fel uppstod när vi försökte spara dina ändringar, vänligen försök igen."
        }
    },
    "edit_profile_user_error_msg": "Vänligen granska fel innan du försöker spara dina ändringar",
    "edit_profile_location_error": "Du måste ange din plats",
    "edit_profile_department_error": "Du måste ange din avdelning \/ division",
    "edit_profile_unspecified_value": "Du måste ange ett värde",
    "edit_profile_value_too_low": "Värdet måste vara mer än",
    "edit_profile_value_too_high": "Värdet måste vara mindre än",
    "choose_gender": "Välj kön",
    "activity_tracked_successfuly": "Din aktivitet spåras",
    "multi_activity_tracked_successfully": "Dina aktiviteter spåras",
    "no_activities_tracked": "Inga aktiviteter spårade",
    "track_activity_to_submit": "Välj ett datum i kalendern för att spåra en aktivitet",
    "last_day": "Sista",
    "days_remaining": "dagar återstår",
    "day_remaining": "återstående dag",
    "days_remaining_this_week": "dagar kvar denna vecka",
    "day_remaining_this_week": "dag kvar denna vecka",
    "days_remaining_this_month": "dagar kvar denna månad",
    "day_remaining_this_month": "dag kvar denna månad",
    "earned_today": "Intjänat idag",
    "earned_this_week": "Intjänat den här veckan",
    "earned_this_month": "Intjänat denna månad",
    "earned_in_total": "Intjänat totalt",
    "goal_completed": "Mål slutfört,",
    "see_results": "se resultat",
    "pts": "%{customPoints}",
    "of": "av",
    "daily_goal": "Dagens mål",
    "weekly_goal": "Veckans mål",
    "monthly_goal": "Månadens mål",
    "total_goal": "Totalt mål",
    "weeks": "veckor",
    "today": "Idag",
    "this_week": "Denna vecka",
    "this_month": "Den här månaden",
    "overall": "Övergripande",
    "level": "Nivå",
    "days_remaining_in_period": "%{remainingDays} dagar kvar",
    "days_left_in_period": "%{remainingDays} dagar kvar att spåra",
    "pointsToLevel": "Framsteg mot %{levelName}",
    "levelCompleted": "%{levelName} slutförd",
    "keepTrackingUntil": "Fortsätt spåra tills",
    "activityLevelTitle": "Min aktivitetsnivå",
    "activityLevelDescription": "Hur mycket tid spenderar du på att vara minst måttligt aktiv – arbeta hårt nog för att höja din hjärtfrekvens och svettas – under en typisk vecka? ",
    "activityLevelUnder60": "Under 60 minuter",
    "activityLevelUnder150": "60 till 150 minuter",
    "activityLevelOver150": "Över 150 minuter",
    "gender_male": "Man",
    "gender_female": "Kvinna",
    "gender_rather_not_say": "Föredrar att inte säga",
    "date_of_birth": "Födelsedatum",
    "height": "Längd",
    "Height": "Längd",
    "weight": "Vikt",
    "waistCircumference": "Midjemått",
    "bloodPressureHg": "Systoliskt blodtryck",
    "bloodPressureMm": "Diastoliskt blodtryck",
    "bloodCholesterol": "Totalt kolesterol i blodet",
    "ldl": "Lågdensitetslipoproteiner",
    "hdl": "Högdensitetslipoproteiner",
    "restingHeartRate": "Vilopuls",
    "percentageBodyFat": "Procent kroppsfett",
    "hipCircumference": "Höftomkrets",
    "bloodGlucose": "Blodsocker",
    "triglycerides": "Triglycerider",
    "error_401_signed_out_message": "Din session har gått ut. Vänligen logga in igen.",
    "first_name": "Förnamn",
    "last_name": "Efternamn",
    "preferred_name": "Föredraget namn",
    "notifications": "Aviseringar",
    "notificationsMarkAllReadButton": "Markera alla aviseringar som lästa",
    "notificationsSettingsButton": "Inställningar",
    "notificationsSettingsTitle": "Aviseringar & e-postmeddelanden",
    "notificationEmptyMessage": "Du är uppdaterad med dina aviseringar",
    "priorityModalTitle": "Mina prioriterade aviseringar",
    "remindMeLater": "Påminn mig senare",
    "priorityAdminTitle": "Meddelande från din administratör",
    "markAsRead": "Markera som läst",
    "expand": "Tryck för att expandera",
    "collapse": "Tryck för att fälla ihop",
    "takePhoto": "Ta ett nytt foto",
    "choosePhoto": "Välj ett foto",
    "deletePhoto": "Radera foto",
    "profileImageChangeErrorTitle": "Ett fel uppstod",
    "profileImageChangeErrorMessage": "Hoppsan... Något gick fel när ditt foto skulle redigeras. Vänligen försök igen.",
    "editProfile": "Redigera profil",
    "postButton": "Publicera",
    "shareYourDayName": "Vad har du för dig?",
    "greeting": "Hej, %{firstNameDisplay}!",
    "shareAnUpdate": "Vad har du för dig?",
    "shareYourDaySubtitle": "Vad har du för dig?",
    "shareAPost": "Dela ett inlägg",
    "postVisibleTo": "Synlig för",
    "link": "Länk",
    "photo": "Foto",
    "insertLink": "Lägg till en länk till ditt inlägg",
    "save": "Spara",
    "sampleLink": "http:\/\/sample.com",
    "shareErrorText": "Du måste lägga till innehåll i ditt inlägg innan du skickar in.",
    "generalErrorTitle": "Inlägget är tomt",
    "generalSuccessTitle": "Lyckades",
    "simplePlaceholder": "Vad har du för dig?",
    "likesCountLabel": "Tummen upp",
    "likesReceivedLabel": "Tummen upp mottagen",
    "commentsCountLabel": "Kommentarer",
    "commentsCountLabelSingular": "Kommentar",
    "likeButton": "Tummen upp",
    "commentButton": "Kommentar",
    "seePreviousComments": "Se föregående kommentarer",
    "addCommentPlaceholder": "Lägg till en kommentar",
    "postCommentButton": "Publicera",
    "seeMoreLongComment": "Läs mer",
    "activityPoints": "%{customPoints}",
    "activityLog": "Aktivitetslogg",
    "discardPost": "Kassera",
    "discardPostMessage": "Är du säker på att du vill kassera ditt inlägg?",
    "stream_filter_title": "Flöde",
    "stream_filter_screen_desc": "Välj de inlägg du vill visa i flödet",
    "stream_filter_selection": "Visar:",
    "moderate": "Markera som olämplig",
    "moderateDescription": "Om du markerar det här objektet som olämpligt kommer det att tas bort och en administratör kommer att meddelas.",
    "editPost": "Redigera inlägg",
    "deletePost": "Radera inlägg",
    "deleteComment": "Radera kommentar",
    "editComment": "Ändra kommentar",
    "visibleOnlyToMe": "Synlig endast för mig",
    "joinEvent": "Besvara inbjudan till evenemanget",
    "joinEventDetail": "Delta i evenemanget",
    "joinedEvent": "Jag kommer",
    "joiningEventToast": {
        "success": {
            "title": "%{eventName}",
            "messageName": "Du har gått med i evenemanget",
            "message": "Du har framgångsrikt gått med i detta evenemang"
        }
    },
    "joinChallenge": "Gå med i utmaningen",
    "viewChallenge": "Visa utmaning",
    "joinedChallenge": "Gick med i utmaningen",
    "joinCommunity": "Gå med i community",
    "joinedCommunity": "Gick med i communityn",
    "joinProgress": "Går med",
    "joinSuccess": "Gick med",
    "invitePeopleToCommunity": "Bjud in personer till community",
    "numberOfMembers": "%{num} medlemmar",
    "joinToView": "Gå med i denna community för att visa och publicera till andra medlemmar",
    "numberOfAttendees": "%{num} deltagare",
    "numberOfParticipants": "%{num} deltagare",
    "numberOfMembersWithUser": "Du och %{num} andra medlem(mar)",
    "numberOfAttendeesWithUser": "Du och %{num} andra deltagare",
    "numberOfParticipantsWithUser": "Du och %{num} andra deltagare",
    "communityMembers": "%{numberOfMembers} medlem(mar)",
    "communityEvents": "%{numberOfEvents} kommande evenemang",
    "myEvents": "Mina evenemang",
    "seeAll": "Se alla",
    "noUpcomingEvents": "Inga kommande evenemang. Gå med i en!",
    "myCommunities": "Mina communities",
    "invitedCommunities": "Inbjuden",
    "invitationSendingMessage": "Skickar inbjudningar...",
    "invitationReceivedMessage": "bjöd in dig att gå med i detta",
    "invitationMessage": "Vi vill gärna ha dig i vår community!",
    "recommendedCommunities": "Rekommenderas för dig",
    "leaveCommunity": "Lämna denna community",
    "leaveTeam": "Är du säker på att du vill lämna laget",
    "leaveTeamLastMember": "i denna utmaning? Eftersom du är den sista medlemmen i laget kommer laget att raderas om du lämnar utmaningen.",
    "leaveTeamChallenge": "i denna utmaning?",
    "Oops": "Oops, någonting gick fel",
    "editCommunity": "Redigera community",
    "deleteCommunity": "Ta bort denna community",
    "leaveCommunityDescription": "Är du säker på att du vill lämna denna community?",
    "inviteToCommunity": "Bjud in till community",
    "inviteByMembers": "Bjud in via namn",
    "inviteByEmail": "Bjud in via e-post",
    "select_person": "Välj minst en person att bjuda in",
    "no_users_found": "Hmm... vi verkar inte kunna hitta någon med det namnet.",
    "promptJoinCommunities": "Det verkar som att du inte gått med i några communities. Gå med i communities för att engagera dig med andra och dela med dig av din resa.",
    "exploreCommunities": "Utforska communities",
    "sendInviteByMembers": "Bjud in %{num} personer",
    "sendInviteByEmail": "Skicka e-postinbjudan",
    "createNewCommunity": "Skapa en ny community",
    "createCommunity": "Skapa community",
    "uploadCover": "Lägg till ett foto",
    "cover": "Skydd",
    "nameOfCommunity": "Namn på community",
    "whatCommunityAbout": "Vad handlar den här communityn om?",
    "companyMembersOnly": "Endast företagsmedlemmar",
    "viewAllButton": "Visa alla",
    "communities": "Communities",
    "contentLibrary": "Bibliotek",
    "events": "Evenemang",
    "past_events": "Tidigare evenemang",
    "invitationCommunity": "community",
    "searchPeople": "Sök personer",
    "enterEmail": "Ange e-postadress",
    "personalMessageToNewInvitees": "Personligt meddelande till nya inbjudna",
    "dangerToastTitle": "Ett fel uppstod",
    "dangerToastMessage": "Hmm... Någonting gick fel. Vänligen försök igen.",
    "successToastTitle": "Lyckades",
    "successToastMessage": "Åtgärden genomförd",
    "joiningToast": {
        "success": {
            "message": "Du gick med"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "Kommentar borttagen"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "Kommentar markerad som olämplig"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "Kommentar uppdaterad"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "Kommentar uppdaterad"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "Profilbild uppdaterad"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "Bild raderad"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "Gör inlägg till flödet",
            "message": "Ditt inlägg har skapats"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "Redigera inlägg",
            "message": "Ditt inlägg har redigerats"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "Radera inlägg",
            "message": "Ditt inlägg har raderats"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "Markera som olämplig",
            "message": "Inlägg markerat som olämpligt"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "Markera som läst",
            "message": "Aviseringarna markerades som lästa"
        },
        "info": {
            "title": "Markera som läst",
            "message": "Alla aviseringar har redan markerats som lästa."
        },
        "danger": {
            "title": "Markera som läst"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "Det gick inte att markera meddelandet som läst"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "Lösenord uppdaterat",
            "message": "Logga in med ditt nya lösenord"
        },
        "danger": {
            "title": "Uppdatera lösenord",
            "message": "Hoppsan... Något gick fel när vi försökte uppdatera ditt lösenord. Vänligen försök igen."
        }
    },
    "joining": {
        "success": {
            "message": "Du gick med i %{name}"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "Inbjudningar",
            "message": "Inbjudning(ar) har skickats"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "Skapa community",
            "message": "Din nya community har skapats"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "Ditt mål har startats om"
        },
        "danger": {
            "message": "Det gick inte att starta om målet"
        }
    },
    "quit": "Avsluta",
    "wellbeing_survey_completed": "Enkät om välbefinnande slutförd",
    "wellbeing_survey_completed_message": "Tack för att du slutfört enkäten. Vi hoppas att detta har hjälpt dig att få lite insikt i ditt välbefinnande.",
    "update_wellbeing_score": "Uppdatera mina enkätsvar",
    "get_wellbeing_score": "Dina välbefinnandepoäng",
    "stats": "Statistik",
    "my_wellbeing_score": "Mina välbefinnandepoäng",
    "see_details": "Se detaljer",
    "how_score_calculated": "Hur beräknas mina poäng?",
    "contentTitle": "Bibliotek",
    "promoted": "Utvalda",
    "recommended": "Rekommenderas",
    "recommendedForMe": "Rekommenderas för mig",
    "recent": "Nyligen upplagda",
    "view": "Visa",
    "added": "Tillagd",
    "more": "mer",
    "openLibrary": "Ta mig till biblioteket",
    "readToEarn": "Läs för att tjäna",
    "readArticle": "Öppna länk",
    "see_more": "Se mer (%{num})",
    "see_more_activities": "%{num} ytterligare",
    "my_achievements": "Mina prestationer",
    "achievements": "Prestationer",
    "achievement_earned_date": "Intjänat: %{date}",
    "achievement_start_date": "Startdatum: %{date}",
    "achievement_end_date": "Slutdatum: %{date}",
    "achievement_earned": "Intjänat",
    "achievement_start": "Startar",
    "achievement_end": "Slutar",
    "achievement_earned_times": "%{num} gånger",
    "achievement_earned_time": "%{num} gång",
    "in_progress": "Pågår",
    "date_earned": "Intjänat datum",
    "earned": "Intjänat",
    "past_dates_earned_heading": "Tidigare intjänade datum",
    "all": "Alla",
    "eat": "Äta",
    "move": "Rörelse",
    "feel": "Känsla",
    "profile_completion": "Slutförd profil: %{percentage}%",
    "complete_my_profile": "Gör färdigt din profil",
    "do_following_tasks": "Gör följande %{num} uppgift(er) för att slutföra din profil.",
    "improve_my_score": "Förbättra dina poäng",
    "see_which_goals": "Kolla in de mål du har satt upp för att äta, röra på dig och må bättre.",
    "havent_set_goal": "Du har inte satt upp ett mål än.",
    "set_a_goal": "Sätt ett mål",
    "set_another_goal": "Sätt ett annat mål",
    "set_another_goal_here": "Sätt ett annat mål här.",
    "my_recently_tracked_activities": "Mina senaste aktiviteter",
    "a_few_seconds_ago": "för några sekunder sedan",
    "a_day_ago": "en dag sedan",
    "yesterday": "Igår",
    "earn": "Tjäna",
    "delete_activity_confirmation": "Är du säker på att du vill ta bort denna aktivitet?",
    "delete_activity_title": "Ta bort %{measurement} av %{activity_name}?",
    "reached_daily_goal": "Du uppnådde ditt mål idag. Bra jobbat!",
    "multiple_activity_non_daily_instruction": "Tryck på en aktivitetsrad för att börja spåra och tjäna %{customPoints}!",
    "multiple_activity_daily_instruction": "Tryck på plustecknet för att spåra hur mycket aktivitet som behövs för att nå ditt mål. Tryck någon annanstans på aktivitetsraden för att spåra vilken mängd som helst av den aktiviteten.",
    "only_automatic_activities": "Aktiviteter som bidrar till detta mål kan endast spåras automatiskt",
    "only_automatic_activity": "Den aktivitet som bidrar till detta mål kan endast spåras automatiskt",
    "earn_pts_and_reach_goal": "Tjäna %{pts} poäng och nå ditt mål genom att spåra %{qty}",
    "earn_pts_for_every": "Tjäna %{pts} poäng för varje",
    "you_track": "du spårar!",
    "you_have_tracked": "Du har spårat %{qty}",
    "so_far": "än så länge!",
    "start_goal": "Ställ in detta mål",
    "about_this_goal": "Om detta mål",
    "start_date": "Startdatum",
    "end_date": "Slutdatum",
    "activities": "Aktiviteter",
    "goal": "Mål",
    "instructions": "Instruktioner",
    "daily": "Varje dag",
    "weekly": "Varje vecka",
    "monthly": "Varje månad",
    "total": "Totalt",
    "week": "Vecka",
    "day": "Dag",
    "days": "Dagar",
    "month": "Månad",
    "months": "Månader",
    "progress": "Framsteg",
    "about": "Om",
    "days_remaining_to_track": "Du har %{num} dagar på dig att spåra missad aktivitet",
    "number_days": "%{num} dagar",
    "one_day": "1 dag",
    "points_earned_this_week": "Poäng som tjänats in denna vecka",
    "points_earned_year": "Poäng intjänade sedan årets början",
    "completed": "Slutförd",
    "what_you_need_to_do": "Så här gör du",
    "see_all_num": "Se alla %{num}",
    "my_week_progress": "Dina veckovisa framsteg",
    "my_day_progress": "Dina dagliga framsteg",
    "my_month_progress": "Dina månatliga framsteg",
    "my_total_progress": "Dina totala framsteg",
    "my_overall_progress": "Övergripande framsteg",
    "you_earned": "Du har tjänat",
    "of_this_week": "av %{num} denna vecka",
    "of_this_day": "av %{num} idag",
    "of_this_month": "av %{num} denna månad",
    "of_this_total": "av totalt %{num}",
    "of_this_overall": "av totalt %{num}",
    "remaining_this_week": "kvar denna vecka",
    "remaining_this_month": "kvar denna månad",
    "remaining_this_total": "återstående",
    "remaining_this_overall": "återstår totalt",
    "view_history": "Visa historik",
    "this_goal_is": "Detta mål är",
    "will_run_for": "Kommer att löpa under",
    "button_unset_goal": "Avmarkera mål",
    "button_leave_challenge": "Lämna utmaningen",
    "leaveChallenge": {
        "menu": "Lämna %{challengeName}"
    },
    "deleteChallenge": {
        "menu": "Ta bort %{challengeName}"
    },
    "unsetGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Du har avmarkerat detta personliga mål."
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Du har lämnat utmaningen."
        }
    },
    "activities_tracked": "Spårade aktiviteter",
    "recently_tracked_activities": "Nyligen spårade aktiviteter",
    "add": "Lägg till",
    "change_before_track": "Det verkar som att du inte har gjort några ändringar. Redigera aktivitetsmängden för denna dag eller avsluta utan att göra ändringar.",
    "havent_tracked_today": "Det verkar som att du inte har spårat någon aktivitet för denna dag ännu. Börja med att söka efter en aktivitet.",
    "cancel_tracking_quantity": "Avbryt spårning %{quantity} av %{activity_name}",
    "points": "%{customPoints}",
    "discard_activity_edits_confirmation": "Om du avslutar kommer redigeringar i din aktivitetshistorik att tas bort. Är du säker?",
    "discard_activity_edits_confirmation_date": "Om du avslutar kommer ändringar i din aktivitetshistorik för %{date} att tas bort. Är du säker?",
    "yes_discard_edits": "Ja, avsluta och kassera redigeringar",
    "createGoal": {
        "navigatorTitle": "Skapa personligt mål",
        "navigatorSubtitle": "Steg %{step} av 4"
    },
    "allCommunities": "Alla",
    "deleteCommunityDescription": "Är du säker på att du vill ta bort denna community?",
    "remaining": "återstående",
    "recommended_goal": "Rekommenderat mål",
    "pinError": "PIN %{pin} är inte giltig. Vänligen försök igen.",
    "previousPersonalGoals": "Mina slutförda personliga mål",
    "previousGoalsTitle": "Mina tidigare mål",
    "endedOn": "slutade den",
    "achievedOfGoal": "Du uppnådde %{num}% av målet",
    "previousGoalsEmptyMessage": "Du har inga tidigare mål",
    "emptyListDefaultMessage": "Du har inga objekt här",
    "myCommunitiesEmpty": "Det verkar som att du inte gått med i några communities. Gå med i communities för att engagera dig med andra och dela med dig av din resa.",
    "discoverMoreCommunities": "Upptäck fler communities",
    "howLong": "Varaktighet",
    "frequency": "Frekvens",
    "discard": "Kassera",
    "description": "Beskrivning",
    "optional": "valfritt",
    "instruction": "Instruktion",
    "name": "Namn",
    "create": "Skapa",
    "categories": "Kategorier",
    "uploadPhoto": "Lägg till ett foto",
    "delete_goal": "Radera detta %{name}",
    "delete_goal_confirmation": "Är du säker på att du vill radera detta mål?",
    "leave_goal_confirmation": "Är du säker på att du vill lämna denna utmaning?",
    "creatingCustomGoalToast": {
        "success": {
            "message": "Ditt mål har skapats."
        }
    },
    "defaultSelectMessage": "Vänligen välj ett alternativ",
    "search": "Sök",
    "inTotal": "totalt",
    "State": "Region",
    "Business unit": "Affärsenhet",
    "Work location": "Arbetsplats",
    "whenStart": "När vill du börja?",
    "every": "varje",
    "acceptChallenge": "Acceptera utmaning",
    "activity_history_challenge": "Aktivitetshistorik för utmaning",
    "havent_tracked_challenge": "Du har inte spårat några aktiviteter för denna utmaning",
    "earned_lowercase": "intjänat",
    "noone_tracked_yet": "Ingen har spårat någonting än. Börja spåra för att ta ledningen i denna tävling!",
    "you": "Du",
    "your_team": "Mitt lag",
    "congrats_first_place": "Grattis, du är på första plats! Fortsätt på den vägen.",
    "leader": "Ledare",
    "average": "Genomsnitt",
    "show_leader": "Visa ledare",
    "show_me": "Visa mig",
    "show_my_team": "Visa mitt lag",
    "leaderboard": "Topplista",
    "my_team": "Mitt lag",
    "remaining_to_track": "återstår att spåra",
    "avg": "medel",
    "invite": "Bjud in",
    "team_members": "Lagmedlemmar",
    "daysLeft": "Dagar kvar",
    "regionNameLiveBetter": "Region",
    "locationNameLiveBetter": "Arbetsplats",
    "departmentNameLiveBetter": "Affärsenhet",
    "regionLabelLiveBetter": "Välj region",
    "locationLabelLiveBetter": "Välj arbetsplats",
    "departmentLabelLiveBetter": "Välj affärsenhet",
    "companyLocation": "Arbetsplats",
    "no_location": "Ingen plats",
    "connect": "Kontakta",
    "syncing": "Synkroniserar",
    "sync": "Synkronisera",
    "havent_tracked_in_a_while": "Inga nyligen spårade aktiviteter",
    "contact": "Kontakta",
    "manage": "Hantera",
    "creator": "Skapad av",
    "allow_notifications": "Hantera aviseringar",
    "enable_notifications": "Starta aviseringar",
    "appload": "Vänligen vänta ett ögonblick medan {app_name} uppdateras...",
    "sendResetEmail": "Skicka e-post för återställning",
    "min": "Min",
    "max": "Max",
    "error_joining_team": "Det gick inte att gå med i laget",
    "cannot_add_to_team": "Hoppsan... Något gick fel när vi försökte lägga till dig i det här laget. Det kan vara så att laget har nått sitt maximala antal medlemmar eller inte längre existerar. Om ett annat fel inträffade, vänligen försök igen.",
    "members_needed": "%{num} medlemmar behövs",
    "member_needed": "%{num} medlem behövs",
    "spots_left": "%{num} platser kvar",
    "join": "Gå med",
    "no_teams_create": "Det finns för närvarande inga team för dig att gå med i. Varför inte skapa ett själv?",
    "number_teams": "%{num} lag",
    "youLowercase": "du",
    "joined_challenge_on_team": "Du har anslutit dig till en utmaning i team %{team_name}.",
    "join_team": "Gå med i ett lag",
    "former_members": "Tidigare medlemmar",
    "letsGo": "Nu kör vi",
    "invite_to_team": "Bjud in till laget",
    "connectingDeviceToast": {
        "success": {
            "title": "Vänligen anslut en app eller enhet",
            "message": "Det lyckades! Din app eller enhet är ansluten."
        },
        "danger": {
            "title": "Vänligen anslut en app eller enhet",
            "message": "Hoppsan... Vi hade problem med att ansluta den här tjänsten. Vänligen försök igen."
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "Koppla bort en app eller enhet",
            "message": "Du har kopplat bort %{name}."
        },
        "danger": {
            "title": "Koppla bort en app eller enhet",
            "message": "Hoppsan... Vi hade problem med att koppla bort %{name}. Vänligen försök igen."
        }
    },
    "leave_entity_question": "Lämna %{name}?",
    "delete_entity_question": "Ta bort %{name}?",
    "leave_team_challenge_confirmation": "Är du säker på att du vill lämna %{name} i denna utmaning?",
    "leave_last_team_member": "Eftersom du är den sista medlemmen i laget kommer laget att raderas om du lämnar utmaningen.",
    "oops_msg": "Hoppsan... Ett fel uppstod när åtgärden skulle utföras. Vänligen försök igen.",
    "has_been_created": "Du har anslutit dig till utmaningen i laget %{name}.",
    "specify_team_name": "Vänligen ange ett lagnamn",
    "invite_members": "Bjud in medlemmar",
    "upload_photo_no_question": "Lägg till ett foto",
    "my_progress": "Mina framsteg",
    "rewardsPointsAdditionalInfo": "Tjäna %{reward_currency} för varje nivå som nåtts varje %{period}. Dina %{customPoints} och nivåer börjar om varje %{period} så du har möjlighet att fortsätta tjäna %{reward_currency} även om du nådde den högsta nivån under den senaste perioden.",
    "rewardsPointsInfo": "Dina %{customPoints} och framsteg återställs varje %{period}.",
    "departments": "Avdelningar \/ Divisioner",
    "regions": "Regioner",
    "noItemsSelected": "Inga objekt valda",
    "pleaseSelectOne": "Välj minst ett objekt i listan",
    "tracked": "Spårad",
    "starts": "Startar",
    "duration": "Varaktighet",
    "bonus": "Bonus",
    "invited_by": "Inbjuden av",
    "create_team": "Skapa ett lag",
    "discardConfirmation": "Är du säker på att du vill avsluta?",
    "discardYes": "Ja",
    "discardStay": "Gå tillbaka",
    "create_team_toast_title": "Skapa ett lag",
    "edit_team": "Redigera team",
    "team_edits_submitted": "Ditt team har uppdaterats.",
    "challenge_ended_still_trackable": "Denna %{type} har avslutats, lyckligtvis har du %{num} dagar kvar att spåra!",
    "tracking_period_ended": "Spårningsperioden för denna %{type} har avslutats.",
    "unlimited": "Obegränsad",
    "ends_in": "Slutar om",
    "challenge_toast": {
        "success": {
            "join": "Det lyckades!",
            "message": "Du har gått med i utmaningen."
        },
        "danger": {
            "error": "Ett fel uppstod",
            "message": "Någonting gick fel. Försök att gå med i utmaningen igen om en liten stund."
        }
    },
    "members_to_invite": "Medlemmar att bjuda in",
    "members_to_remove": "Medlemmar att ta bort",
    "myChallenges": "Tävlingar",
    "upcoming": "Kommande",
    "myPersonalGoals": "Mål",
    "companyCompetitions": "Företagstävlingar",
    "communityCompetitions": "Communitystävlingar",
    "edit_your_team": "Redigera ditt lag",
    "emails": "E-postmeddelanden",
    "CompletedOverall": "Totalt slutförda",
    "TotalEarned": "Totalt intjänade",
    "notify_header": "Jag skulle vilja bli underrättad:",
    "AdditionalBonus": "Ytterligare bonus",
    "goalEndedNotification": "Mål avslutat, fortsätt anstränga dig!",
    "compEndedNotification": "Tävlingen avslutad, fortsätt anstränga dig!",
    "congrats_tracking_first": "Grattis, du spårar din första aktivitet!",
    "keep_tracking": "Fortsätt spåra din aktivitet för att uppnå mål och nå nästa nivå.",
    "understanding_tracking": "Förstå spårning",
    "cannot_track_this_day": "Du kan inte spåra den här dagen.",
    "nothing_tracked_this_day": "Du har ännu inte spårat denna dag.",
    "tracked_something_this_day": "Du har spårat något den här dagen.",
    "reached_goal_this_day": "Du har nått ditt mål för denna dag (endast för dagliga mål).",
    "got_it": "Uppfattat!",
    "notDismissedMultiTitle": "Sammanfattning av utmaningen",
    "notDismissedMultiSubtitle": "Några utmaningar har avslutats. Ta en djupare titt på var och en för detaljer om hur du presterade. ",
    "daySummary": "%{userName}, här är en sammanfattning av din dag hittills",
    "goals": "Mål",
    "competitions": "Tävlingar",
    "totalAccumulated": "Summa ackumulerade",
    "tracking_for_date": "Spårning för %{date}",
    "activity_tracker_instruction": "Tryck för att redigera eller ta bort en manuellt spårad aktivitet",
    "ended": "Slutade",
    "notYetAvailableBeta": "Ännu inte tillgängligt i beta",
    "suggestedGoal": "Föreslaget mål",
    "singleFor": "för",
    "seeLessLongComment": "Visa mindre",
    "synced_data": "Synkroniserad data:",
    "doThisLater": "Jag kommer att göra detta senare",
    "inviteUsers": "Bjud in andra att gå med",
    "cannotTrackAfterDeadline": "Du försöker spåra en aktivitet för ett datum efter utmaningens slutdatum.",
    "potentialBonusPoints": {
        "section": {
            "title": "%{potentialBonusPoints} bonus %{customPoints} är tillgänglig för detta mål!",
            "titleNotCompleted": "Du missade %{potentialBonusPoints} bonusen %{customPoints} med %{activitytCompletedPercentage}%.",
            "titleCompleted": "Grattis! Du har tjänat",
            "titleCompletedBold": "%{potentialBonusPoints} bonus %{customPoints}!",
            "subtitle": "Läs mer om bonusar %{customPoints}"
        },
        "modal": {
            "title": "Bonus %{customPoints}",
            "desc1": "Vi vet att ingen är perfekt och når sina mål 100% av tiden.",
            "desc2": "Det är därför vi tilldelar bonusen %{customPoints} när din totala framgång är 85% eller mer.",
            "desc3": "Alla bonusar %{customPoints} tilldelas efter att målet har avslutats och om all din spårning gjordes från en ansluten app eller enhet får du dubbel bonus %{customPoints}!",
            "desc4": "Du kommer inte att få en bonus på %{customPoints} för mål som du lämnar i förtid."
        },
        "msg": {
            "title": "Detta mål har avslutats",
            "subtitle": "Mål slutade %{goalEndedDate}"
        },
        "msgEnded": {
            "title": "Tiden är slut! Ditt mål har avslutats",
            "subtitle": "Du har %{daysNum} %{daysOrDay} på dig att spåra din aktivitet."
        }
    },
    "finish": "Slutför",
    "personalGoal": {
        "all_goals": {
            "selected": "Alla %{maxGoals} mål satta!",
            "description": "Tycker du om det här? Du kan ersätta alla mål om du ändrar dig. Oroa dig inte, du kommer att kunna ta bort ditt mål senare.",
            "set": "Alla mål har satts upp!",
            "action": "Allt klart, redo att köra igång!",
            "error": "Förhasta dig dock inte! Genom att fokusera på 3 rekommenderade mål i taget kommer din sannolikhet för framgång att öka.",
            "errorHeading": "Sätta mål"
        },
        "set_more": "Du kan ange %{maxGoals} mer aktiva mål",
        "select_goal": {
            "heading": "Ange ett rekommenderat mål eller skapa ditt eget"
        },
        "set_more_1": "Du kan sätta ytterligare 1 aktivt mål"
    },
    "restartPersonalGoal": "Starta om målet med nya ambitioner",
    "delete_challenge_confirmation": "Är du säker på att du vill radera denna utmaning?",
    "personal_goal_unit": "mål",
    "personal_goal_units": "mål",
    "day_summary": {
        "steps_taken": "Åtgärder som vidtagits",
        "calories_in": "Kalorier in",
        "calories_out": "Kalorier ut",
        "avg_daily": "dagligt medelvärde",
        "most_earned_daily": "mest intjänade per dag"
    },
    "invitedBy": "Inbjuden av %{person}",
    "resetPasswordMissingField": "Vänligen skriv in en e-postadress",
    "resetPasswordInvalidValue": "Vänligen ange en giltig e-postadress",
    "resetPasswordNotFound": "Din e-postadress kan inte hittas",
    "resetPasswordNotCompleted": "Din förfrågan kunde inte slutföras",
    "resetGoalInstructions": {
        "start": "Gör %{quantity} %{units} av %{activity}",
        "additional": ", %{quantity} %{units} av %{activity}",
        "end": "%{frequency} och tjäna %{points} %{customPoints} %{frequency}"
    },
    "goalSet": {
        "one": "Ett uppsatt mål. Visa",
        "two": "Två uppsatta mål. Visa",
        "three": "Tre uppsatta mål. Visa",
        "none": "Inga mål uppsatta. Ange mål"
    },
    "searchCommunitiesEmpty": "Inga communities hittades",
    "searchCommunitiesPlaceholder": "Sök communities",
    "updating": "Uppdaterar...",
    "pts_tracked": "Spårade %{activityName} - %{num} %{customPoints}",
    "improving_wellbeing_score": "Fortsätt på den vägen, du är på väg att förbättra dina välbefinnandepoäng.",
    "progressHistory": "Framstegshistorik",
    "privateCommunity": "Detta är en privat community",
    "do_combo_of_activities": "Gör någon kombination av följande.",
    "noActivitiesTracked": "Inga aktiviteter spårade",
    "trackingWithFollowingApps": "Spårning med följande appar\/enheter",
    "recommendedApps": "Rekommenderade appar\/enheter för denna %{challengeType}",
    "collapseWord": "Minimera",
    "started": "Startad",
    "ends": "Slutar ",
    "do_activities": "Utför aktiviteter",
    "rewards_placeholder": "Exempel på belöningar från butiken, platshållare. Användare kommer att se olika produkter de kan köpa och vad de kostar i %{rewardName}.",
    "personalGoals": {
        "top": {
            "label": "Topp"
        },
        "allGoals": "Alla mål",
        "seeMoreCard": {
            "heading": "Hittar du inte personen du letar efter?",
            "description": "Ta en titt på alla rekommenderade mål",
            "button": "Utforska mål"
        }
    },
    "rewardsNotAvailable": "Belöningar är för närvarande inte tillgängliga i den här betaversionen. När de är tillgängliga kommer du att kunna se katalogen och göra en inlösen.",
    "editProfileProvideRestingHeartRate": "Ange en giltig vilopuls på minst 40",
    "liveBetterHealthInfo": "Vi kör ett antal program och har en mängd olika hälsoinnehåll utformade för att stödja en rad hälsobehov och hjälpa dig att uppnå Bättre Hälsa. Vi har ännu inte program för alla hälsotillstånd och behov – vi arbetar på det! – men om du svarar på följande frågor, kommer vi att kontakta dig om vi identifierar några hälsoprogram eller tjänster som du kan ha nytta av att delta i och\/eller skicka dig evidensbaserad information som hjälper dig att bättre förstå och hantera dina hälsobehov. Observera att vi inte använder denna information för att bedöma om din policy är lämplig. Om du vill ta reda på vad du omfattas av eller har några frågor om din policy kan du ringa vår kundservice på 132 331.",
    "deleteGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Du har tagit bort målet"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Du har tagit bort utmaningen"
        }
    },
    "invitations": "Inbjudningar",
    "learnMorePeriods": "Läs mer om perioder",
    "tracked_by_app_name": "Spåras av %{app_name}",
    "device_required": {
        "text": "Denna %{challengeType} kräver en app eller enhet",
        "button": "Vänligen anslut en app eller enhet"
    },
    "editingCommunityToast": {
        "success": {
            "title": "Redigera community",
            "message": "Community har redigerats"
        }
    },
    "competition": "Tävling",
    "close": "Stäng",
    "only_automatic_activities_with_device": "Denna %{goal_or_competition}'s aktiviteter spåras automatiskt med dina anslutna appar\/enheter.",
    "only_automatic_activity_with_device": "Denna %{goal_or_competition}'s aktivitet spåras automatiskt med dina anslutna appar\/enheter.",
    "deletingCommunityToast": {
        "success": {
            "title": "%{name}",
            "message": "Community raderad"
        }
    },
    "teamSizeMessage": "Ditt team behöver minst %{min} personer för att tjäna %{customPoints} för utmaningen.",
    "captain": "Kapten",
    "inviteOthersToTeam": "Bjud in andra till mitt lag",
    "loadingMetrics": "Ansluter till källor för att uppdatera din dag...",
    "aboutTeamSize": {
        "title": "Lagstorlek",
        "text": "%{min} till %{max}"
    },
    "pointsOverview": "%{customPoints} översikt",
    "deepLinks": {
        "requestCouldNotBeCompleted": "Din förfrågan kunde inte slutföras",
        "error": "Ett fel uppstod"
    },
    "required_lc": "nödvändig",
    "personal": "Personuppgifter",
    "biometrics": "Biometri",
    "makeSelection": "Välj urval",
    "ask_question_success_msg": "Tack. Vi svarar så fort vi kan.",
    "report_issue_success_msg": "Tack. Vi svarar så fort vi kan.",
    "ask_question_success_title": "Din fråga har skickats",
    "report_issue_success_title": "Tekniskt problem skickat",
    "ask_question_failure_msg": "Vilken besvikelse... Ett fel uppstod när din fråga skulle skickas, vänligen försök igen.",
    "report_issue_failure_msg": "Vilken besvikelse... Ett fel uppstod när ditt problem skulle rapporteras, vänligen försök igen.",
    "notTrackedActivities": "Du har inte spårat några aktiviteter för denna period",
    "learn": "Lär dig",
    "Balance": "Balans",
    "details": "Detaljer",
    "Reward": "Belöning",
    "levelsReset": "Nivåer återställs om %{remainingDays} dagar",
    "redeem": "Lös in",
    "redeemAt": "Lös in vid %{points}",
    "needPointsToRedeem": "Du behöver %{points} mer %{rewardName}.",
    "learnEarnMore": "Lär dig om hur du kan tjäna mer",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "Gå med i ett lag",
            "message": "Du har gått med i laget!"
        },
        "danger": {
            "message": "Vi har stött på ett fel och kunde inte hitta laget. Det kanske inte längre existerar."
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "Åtgärden är inte tillgänglig",
            "message": "Din förfrågan kunde inte slutföras."
        }
    },
    "transactionLog": "Transaktioner",
    "orderHistory": "Ordrar",
    "pointsAvailableToEarn": "%{points} tillgängliga att tjäna",
    "missedYTD": "%{missed} missade YTD",
    "rewardsDetails": "Belöningar",
    "successfullyRedeemedItem": "Du har löst in det här objektet",
    "orderNumber": "Beställningsnummer",
    "amountSpent": "Belopp som använts",
    "status": "Status",
    "dateRedeemed": "Datum inlöst",
    "additionalInformation": "Ytterligare information",
    "shipToAddress": "Leverera till den här adressen",
    "pointMissedYearToDate": "%{rewardCurrencyName} missade i år",
    "pointMissedYearToDateDescription": "När du inte uppnår en nivå innan perioden är slut anses de tillhörande %{rewardCurrencyName} som du kunde ha tjänat ha missats.",
    "NoLibraryContentToast": {
        "info": {
            "title": "Ingen artikel hittades",
            "message": "Det gick inte att hitta artikeln. Den kan ha tagits bort eller inte längre vara tillgänglig."
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "Community hittades inte",
            "message": "Kunde inte hitta community. Den kan ha tagits bort eller inte längre vara tillgänglig."
        }
    },
    "shippingAddress": "Leverans- \/ faktureringsadress",
    "enterShippingAddress": "Ange din leverans- \/ faktureringsadress",
    "streetLine": "Gatunamn %{num}",
    "stateProvince": "Region\/Län",
    "postcodePostalcodeZip": "Postnummer\/Postnummer\/Postnummer",
    "phoneNumber": "Telefonnummer",
    "order": "Ordning",
    "redemptionConfirmation": "Bekräftelse på inlösen",
    "edit": "Redigera",
    "processing": "Bearbetar",
    "checkIsYouFirst": "Vi behöver bara kolla om det är du först",
    "discardSomeGoals": "Du har satt upp några mål. Dessa mål kommer att kasseras om du fortsätter.",
    "settingGoalsToast": {
        "success": {
            "message": "Dina nya mål har satts upp!"
        }
    },
    "one_team": "1 lag",
    "noAchievementsToEarnMessage": "Det verkar som om det inte finns några fler märken för att tjäna %{rewardCurrencyName} den här perioden.",
    "shopRewards": "Butiksbelöningar",
    "validateShippingAddressToast": {
        "danger": {
            "title": "Leverans- \/ faktureringsadress",
            "message": "Vänligen fyll i alla fält innan du fortsätter."
        }
    },
    "viewDetails": "Visa information",
    "potential": "Potentiellt",
    "missed": "Missade",
    "rewardsStoreNotAvailable": "Belöningsbutiken är inte tillgänglig för dig just nu.",
    "havent_tracked_in_a_while_date": "Inga aktiviteter spårade för %{currentDate}",
    "challengeNotFoundToast": {
        "danger": {
            "title": "Utmaningen hittades inte",
            "message": "Kunde inte hitta utmaning. Den kan ha tagits bort eller inte längre vara tillgänglig."
        }
    },
    "shareYourDaySubtitleActivity": "Lägg till en bild eller säg något om den här aktiviteten!",
    "goal_ended": "Mål avslutat",
    "challenge_ended": "Utmaningen har avslutats",
    "day_remaining_to_track": "Du har 1 dag på dig att spåra missad aktivitet",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal} slutade %{endDate}",
    "goalEndedModal": {
        "title": "Spåra ikapp glömd aktivitet",
        "message": "När ett personligt mål eller utmaning har avslutats har du tre dagar från slutdatumet att spåra alla aktiviteter som du kan ha glömt. Efter denna period kan du inte spåra några ytterligare aktiviteter som bidrar till målet eller utmaningen."
    },
    "summary": "Sammanfattning",
    "placedRank": "Du är placerad %{rank} av %{total}",
    "rank": {
        "first": "1:a",
        "second": "2:a",
        "third": "3:a",
        "n": "%{rank}"
    },
    "event_name": "Evenemangets namn",
    "this_is": "Detta är ett  ",
    "location_info": "Plats & information",
    "what_event": "Vad handlar det här evenemanget om",
    "event_is": "Det här evenemanget är",
    "start_on": "Börja den:",
    "end_on": "Sluta den:",
    "location": "Plats",
    "chooseLeaderboard": "Välj en topplista",
    "filterOneOfFollowing": "Filtrera något av följande",
    "showChallengeInstead": "Visa en utmaning istället",
    "showActivityInstead": "Visa en aktivitet istället",
    "showAll": "Visa alla",
    "activitiesShowSame": "Aktiviteter: %{activityName}",
    "challengeShowSame": "Utmaning: %{challengeName}",
    "chooseTimePeriod": "Välj en tidsperiod",
    "youCanFilterOneAtTime": "Ett filter kan väljas åt gången",
    "saveHealthTopicsToast": {
        "success": {
            "message": "Hälsoämnen sparade",
            "title": "Det lyckades!"
        },
        "info": {
            "message": "Kan inte spara"
        },
        "danger": {
            "title": "Fel!"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "Hälsomål sparade",
            "title": "Det lyckades!"
        },
        "info": {
            "message": "Kan inte spara"
        },
        "danger": {
            "title": "Fel!"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "Intressen sparade",
            "title": "Det lyckades!"
        },
        "info": {
            "message": "Kan inte spara"
        },
        "danger": {
            "title": "Fel!"
        }
    },
    "edit_event": "Redigera evenemang",
    "leave": "Lämna",
    "delete_event": "Radera evenemang",
    "no_events": "Inga evenemang",
    "no_events_placeholder": "Du planerar för närvarande inte att delta i några framtida evenemang. Varför går du inte med i ett?",
    "event": "evenemang  ",
    "challenge": "Utmaning",
    "invited_you": "Inbjuden",
    "public": "Offentlig",
    "private": "Privat",
    "deleteEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Evenemanget har tagits bort."
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Du har lämnat evenemanget"
        }
    },
    "editEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Evenemanget har uppdaterats."
        }
    },
    "createEventToast": {
        "success": {
            "message": "Evenemanget har skapats.",
            "title": "%{eventName}"
        }
    },
    "contentIsDeletedOrInappropriate": "Innehållet du försöker visa är för närvarande inte tillgängligt. Det kan ha raderats av författaren eller markerats som olämpligt.",
    "start_time": "Starttid",
    "end_time": "Sluttid",
    "event_type": "%{eventType} evenemang",
    "leave_event_modal": {
        "title": "Om du lämnar detta evenemang",
        "message": "Det kommer att raderas"
    },
    "leave_event ": "Är du säker på att du vill lämna detta evenemang?",
    "create_event": "Skapa evenemang",
    "created_by": "Skapad av",
    "eventActionToast": {
        "danger": {
            "title": "Ett fel uppstod",
            "message": "Någonting gick fel. "
        }
    },
    "continue": "Fortsätt",
    "wantExitTour": "Är du säker på att du vill avsluta rundturen?",
    "exitTour": "Avsluta rundturen",
    "deleveEventPopup": "Är du säker på att du vill radera detta evenemang?",
    "attendeesTitle": "Deltagare",
    "userEvents": "%{name}s evenemang",
    "createEventIndicator": "Skapar evenemang",
    "inviteToEvent": "Bjud in till evenemang",
    "noDescription": "Det finns ingen beskrivning.",
    "leaderboardIsEmpty": "Den här topplistan är tom eller så kan du behöva spåra aktivitet inom den valda tidsperioden för att se den",
    "notParticipantingInAnyChallenges": "Du deltar inte i några utmaningar",
    "buttonLeaveEvent": "Lämna evenemang",
    "leaveEvent ": "Lämna %{name}?",
    "canceledCreatingChallenge": "Skapandet av en %{challengeType} har avbrutits",
    "swipeReadNotification": "Läs",
    "productTour": {
        "initialScreen": {
            "title": "Välkommen till %{programName}!",
            "body": "Låt oss ta en rundtur och om en liten stund kommer du att veta grunderna."
        },
        "dashboard": {
            "title": "Kontrollpanel",
            "body": "Se hur många %{pointsName} du har och dina framsteg mot nivåer. Kolla sedan in topplistan för att se hur det går för dig."
        },
        "rewards": {
            "title": "Belöningar",
            "body": "Se hur många %{rewardPointName} du har och lös in dem i butiken."
        },
        "goals": {
            "title": "Mål & utmaningar",
            "body": "Dina aktiva personliga mål, utmaningar med andra och speciella uppgifter hittar du här."
        },
        "explore": {
            "title": "Utforska",
            "body": "Hitta utmaningar med andra, gå med i communities för att diskutera dina intressen och upptäck en ny artikel i välmåendebiblioteket."
        },
        "me": {
            "title": "Mig",
            "body": "Hitta dina välbefinnandepoäng, kontrollera din statistik och redigera din profil & inställningar här."
        },
        "finishScreen": {
            "title": "Du är redo",
            "body": "Tack för att du slutförde rundturen.",
            "button": "Dags att sätta igång"
        },
        "skip": {
            "title": "Är du säker på att du vill hoppa över rundturen?",
            "body": "Detta kommer att avsluta turen och du kan komma igång direkt."
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "Behörighetskontroll misslyckades",
            "message": "Det gick inte att fortsätta med inlösen av belöningar. Ett fel uppstod vid autentisering med belöningsleverantören."
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "Inlösen misslyckades",
            "message": "%{displayMessage}"
        }
    },
    "disclamerSectionTitle": "Innan du börjar",
    "disclamerSectionMessage": "Kontrollera med din sjukvårdspersonal innan du startar något nytt träningsprogram eller gör livsstilsändringar för att säkerställa att de är lämpliga för dig.",
    "noEarchedAchievements": "Du har inte tjänat ihop några prestationer ännu. Spåra en aktivitet för att komma igång.",
    "noInProgressAchievements": "Du har inga pågående prestationer.",
    "discardCreatingEventMessage": "Kontrollera att alla obligatoriska fält har angetts",
    "discardCreatingEventTitle": "Evenemanget kan inte skapas",
    "discardEditedEventTitle": "Evenemanget kan inte redigeras",
    "errorEventNameMessage": "Namn är obligatoriskt",
    "errorEventStartDateMessage": "Startdatum krävs",
    "errorEventEndDateMessage": "Slutdatum krävs",
    "errorEventDateMessage": "Slutdatumet kan inte inträffa tidigare än startdatumet",
    "noAccountsToLink": "Det finns inga konton tillgängliga för att länka till %{program_name}.",
    "accountLinkEmailChanged": "Din e-postadress har uppdaterats. I fortsättningen kan du logga in med ditt länkade konto.",
    "accountLinkSuccessful": "Ditt konto har länkats.",
    "edit_profile_nan_value": "Värdet måste vara ett nummer",
    "advancedLogIn": "Avancerad inloggning",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "Inlösen misslyckades",
            "message": "Beställnings-sessionen har löpt ut. Vänligen försök att beställa igen."
        }
    },
    "left": "vänster",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "Det verkar som om det inte finns några evenemang tillgängliga att delta i just nu. Varför inte skapa ett själv?"
        }
    },
    "reachedHighestLevel": "Du har nått den högsta nivån!",
    "error": "Ett fel uppstod",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "Belöningsinlösen",
            "message": "Din beställning har gjorts"
        }
    },
    "redeemRewardComplete": "Inlösen slutförd",
    "trackActivityTitle": {
        "oneUnit": "Spår: 1 %{unit} av %{activity} den %{date}",
        "nUnit": "Spåra: %{activity} för %{date}"
    },
    "ssoAuthenticationFailure": "Behörighetskontroll misslyckades",
    "earnEvery": "Tjäna varje %{frequency}",
    "earnOnce": "Tjäna bara en gång",
    "goalSettings": {
        "maximumSet": "Du har för närvarande maximalt 3 uppsatta mål.",
        "learnMore": "Läs mer om att sätta mål"
    },
    "allowMarketingComms": "Skicka reklamkommunikation till mig",
    "allowPartnerMarketingComms": "Skicka reklamkommunikation till mig från partners",
    "noUpcomingAchievements": "Du har inga kommande prestationer.",
    "settingGoalToast": {
        "success": {
            "message": "Ditt nya mål har satts!"
        }
    },
    "authentication": {
        "saml": {
            "error": "Tjänsten för närvarande inte tillgänglig",
            "signin": "Integrerad inloggning",
            "signup": "Integrerad registrering"
        }
    },
    "monthName": {
        "january": "Januari",
        "february": "Februari",
        "march": "Mars",
        "april": "April",
        "may": "Maj",
        "june": "Juni",
        "july": "Juli",
        "august": "Augusti",
        "september": "September",
        "october": "Oktober",
        "november": "November",
        "december": "December"
    },
    "promotedForMe": "Utvalda",
    "appRating": {
        "enjoying": "Gillar du vår app?",
        "feedback": "Vill du ge lite feedback?",
        "appStore": "Betygsätta oss i App Store?",
        "googlePlay": "Betygsätt oss på Google Play?",
        "notReally": "Inte riktigt",
        "yes": "Ja!",
        "sure": "Visst",
        "noThanks": "Nej tack",
        "notNow": "Inte nu"
    },
    "getMobileApp": "För att använda %{programName} på din smartphone, ladda ner %{appStoreName} från App Store eller Google Play.",
    "newAppsDevicesDesign": {
        "getMobileApp": "Ladda ner appen %{programName}",
        "searchInAppStore": "Sök efter %{programName} i App Store eller Google Play.",
        "getMobileAppNoName": "Skaffa mobilappen"
    },
    "editorAlert": {
        "discardChanges": "Bortse från ändringar",
        "saveAndContinue": "Spara och fortsätt",
        "title": "Ändringar som inte sparats",
        "text": "Du har gjort några ändringar som inte har sparats. Vad vill du göra?"
    },
    "resources": "Resurser",
    "noResources": "Inga resurser tillgängliga",
    "viewAllResources": "Visa alla resurser",
    "language": "Språk",
    "eventStarted": "Evenemanget började. Registreringen är stängd.",
    "Gender": "Kön",
    "show": "Visa",
    "hide": "Dölj",
    "timeoutError": "Hoppsan! Någoting tar för lång tid. Vänligen försök igen senare.",
    "SOT": {
        "sample_task": "Provuppgift"
    },
    "cache": {
        "new_version": "En ny version finns tillgänglig!",
        "refresh_browser": "Klicka här för att uppdatera din webbläsare."
    },
    "welcomeUser": "Välkommen, %{userFirstName}!",
    "quarter": "kvartal",
    "completionReward": "Belöning för slutförande",
    "bronzeLevel": "Bronsnivå",
    "deviceAppSyncingOk": "Synkronisering av enhet \/ app ok",
    "deviceAppSyncingIssue": "Synkroniseringsproblem för enhet \/ app",
    "deviceAppSyncingError": "Synkroniseringsfel för enhet \/ app",
    "lastSync": "Senaste synkronisering",
    "period": "period",
    "yourDaySummary": "Din dag hittills",
    "steps": "Steg",
    "gender_non_binary": "Icke-binär eller icke-anpassande",
    "take_survey": "Delta i undersökningen",
    "social": "Socialt",
    "finalDay": "Sista dagen",
    "leaderboard_position": "Position i topplistan",
    "signUp": {
        "apple": {
            "disconnectSettings": "Koppla bort %{appName} från \"Apple ID Password & Security\" i telefoninställningarna för att fortsätta registrera dig"
        }
    },
    "earnPoints": "Tjäna %{customPoints}. Gå upp en nivå.",
    "getReward": "Få %{rewardName}.",
    "buildHealthyHabits": "Bygg hälsosamma vanor.",
    "highestLevelIndicator": "Du har nått den högsta nivån!",
    "highestLevelIndicatorNew": "Du har slutfört alla nivåer!",
    "trackYourActivity": "För att få %{customPoints}, spåra din tränings- och hälsoaktivitet.",
    "levelUpToGetRewarded": "När du når högre nivåer kommer du att belönas med %{rewardName}.",
    "levelUpAndEarn": "Dina framsteg återställs varje %{period}, så att du kan höja nivån och tjäna om och om igen.",
    "levelUp": "Dina framsteg återställs varje %{period}, så att du kan höja din nivå om och om igen.",
    "goToLibrary": "Gå till biblioteket",
    "updateEventIndicator": "Uppdaterar evenemang",
    "meTour": {
        "healthSurveyDisabled": "Kontrollera din statistik och redigera din profil & inställningar här."
    },
    "createNewGoal": "Skapa ett nytt mål",
    "later": "Senare",
    "bonusChallenge": "Bonusutmaning",
    "bonusChallengeInfo": {
        "withReward": "Du får %{amount} i bonus %{points} för att ha slutfört minst 85% av denna %{challengeType}.",
        "noReward": "Du får en bonus om du slutför minst 85% av denna utmaning.",
        "boldText": "%{amount} bonus %{points}",
        "noRewardChallengeType": "Du får en bonus för att ha slutfört minst 85% av denna %{challengeType}."
    },
    "defaultApp": "Din standardapp för hälsa",
    "bonusGoal": {
        "additionalInfo": "Om all din aktivitet spårades med en ansluten app eller enhet får du dubbel bonus %{points}!",
        "additionalInfoNew": {
            "paragraph2": "Bonusen %{points} tilldelas efter att målet har avslutats. Du kommer inte att få en bonus på %{points} för mål som du lämnar i förtid."
        },
        "boldText": "dubbel bonus %{points}!",
        "markTitle": "Bonus"
    },
    "notify_me": "Avisera mig",
    "bonusChallengeReward": "Belöning för bonusutmaning",
    "forCompletingChallenge": "För att ha slutfört %{challengeName}",
    "notifications_text": "Aviseringar hjälper dig att hålla fast vid dina mål och hålla dig uppdaterad med konversationer.",
    "type_here": "Skriv här",
    "bonusEarned": "Bonus intjänad",
    "youEarnedBonus": "Du har tjänat denna bonus!",
    "inviteOthersToChallenge": "Bjud in andra att gå med",
    "inviteOthersToYourTeam": "Bjud in andra till ditt lag",
    "manageTeam": "Hantera lag",
    "ft": "ft",
    "lbs": "lbs",
    "cm": "cm",
    "kg": "kg",
    "community": "community",
    "chooseActivity": "Välj aktivitet",
    "Recent": "Senaste",
    "noActivities": "Inga matchande aktiviteter",
    "photoChooseText": "Välj",
    "photoCancelText": "Avbryt",
    "signIn": {
        "missingEmail": "E-postadress saknas",
        "missingPassword": "Vänligen se till att lösenordet är angivet",
        "invalidLogin": "Inloggning misslyckades",
        "accountLocked": "Ditt konto är låst. Vänligen kontakta din administratör",
        "accountMayNotExist": "Vi har inget konto för den här e-postadressen. Registrera dig för att skapa ett konto.",
        "wrongPassword": "Fel lösenord. Försök igen eller klicka på Glömt lösenord för att återställa det."
    },
    "deleteGoalBonusPoints": "Om du inte har tjänat in den tillhörande bonusen än, kommer du inte längre att kunna göra det.",
    "havent_tracked_goal": "Du har inte spårat några aktiviteter för detta mål",
    "trackActivity": {
        "search": "Sök aktiviteter...",
        "text": "Spåra aktivitet",
        "done": "Klar",
        "discardChanges": "Kassera ändringar?",
        "discardMessage": "Är du säker på att du vill avsluta och kassera dina framsteg?",
        "discard": "Kassera",
        "limitMessage": "Du kan bara spåra upp till sju dagar åt gången.",
        "inputDescription": "Mängd %{activity} för %{date}",
        "gracePeriod": "Du har %{n} %{text} att spåra missad aktivitet"
    },
    "dates": "Datum",
    "pickDates": "Välj andra datum",
    "selectDates": "Välj datum",
    "limitReached": "Du har nått gränsen",
    "activity": "Aktivitet",
    "keepUpTheGoodWork": "Bra jobbat!",
    "activityTracked": "Aktivitet spårad",
    "new": "Nyhet",
    "newFeatureTitle": "Enklare, snabbare aktivitetsspårning",
    "newFeatureText": "Oavsett om du spårar aktivitet från idag, från det förflutna eller under flera dagar, tror vi att du kommer att älska den nya upplevelsen.",
    "gotIt": "Uppfattat!",
    "frequencyViewHistory": "Visa %{frequency} -översikt",
    "challengeDetails": {
        "trackTheseActivities": "Spåra någon av dessa aktiviteter för att göra framsteg mot denna %{challengeType}."
    },
    "member": "medlem",
    "weeklyBreakdown": "Veckofördelning",
    "setGoals": {
        "earnPointsText": {
            "start": "Tjäna",
            "end": "för att sätta ditt första mål!"
        }
    },
    "weeklyGoalEnded": "Veckan slutade den",
    "weekFinished": "Du avslutade en vecka av",
    "restartGoal": {
        "daysLeftToTrack": "Du har fortfarande %{quantity} %{days} på dig att spåra eventuella glömda framsteg från förra veckan.",
        "weekEnded": "Den här veckan är över.",
        "timesUp": "Tiden är slut!",
        "period": {
            "title": "Målperiod",
            "text": "Måndag till söndag, varje vecka"
        }
    },
    "membersPlural": "Medlemmar",
    "startedADayAgo": "Började för 1 dag sedan",
    "goalRestarted": "Du har startat om detta mål",
    "weeklyGoals": "Veckomål",
    "weeklyGoalsDescription": "Veckans mål förnyar sig varje måndag, så att du kan hålla upp en hälsosam vana under en lång tid.",
    "challengeEnded": "Denna %{challengeType} har avslutats",
    "goalEndedModalTitle": "Tiden är slut! Din %{challengeType} har avslutats!",
    "yourProgress": "Dina framsteg",
    "earn_withRewards": "Spåra din hälsosamma aktivitet för att tjäna (%{pts}) och godkänt nivåer. När du går upp i nivå får du %{currency}.",
    "earn_noRewards": "Suivez votre exercice et votre activité de bien-être pour gagner (%{pts}) et passer au niveau supérieur.",
    "currentPeriod": "Aktuell period",
    "currentScore": "Nuvarande poäng",
    "viewActivityLog": "Aktivitetslogg",
    "balanceHistory": "Min balanshistorik",
    "mymedibank": {
        "underAge": {
            "error": "Live Better-appen är endast tillgänglig för användare som är 18 år eller äldre, se Live Better-villkoren för mer information."
        }
    },
    "enhancedHomePageInfo": "Vi har städat upp på hemsidan! Det är nu lättare att se dina utmaningar och mål. Dags att spåra!",
    "levelUpTitle": "Gå upp en nivå",
    "levelUpDescription": "Avancera mellan nivåer genom att spåra aktiviteter och slutföra mål och utmaningar. När du når högre nivåer kommer du att belönas med %{currency}!",
    "achievementsDescription": "Lås upp dessa speciella märken för att tjäna %{currency}. Klicka på ett märke för att se vad du behöver göra.",
    "bonusChallengesDescription": "Gå med och slutför utmaningar som har en %{currency}-bonus.",
    "earnWithPartners": {
        "title": "Tjäna mer med partners",
        "description": "Medibank-medlemmar med sjukhus- eller extratäckning kan tjäna poäng på berättigade inköp\/aktiviteter med partners."
    },
    "browseAllPartners": "Bläddra bland alla partners",
    "resetsIn": "Återställs om %{daysNumber} dagar",
    "thisIsALot": "Det här är mycket!",
    "areYouSure": "Är du säker?",
    "trackingALotMessage": {
        "days": "Du spårar över 2 000 %{customPoints} under %{daysNum} dagar. Det är en hel del!",
        "day": "Du spårar över 2 000 %{customPoints} på 1 dag. Det är en hel del!"
    },
    "amSure": "Jag är säker på",
    "activeMinutesAndSleep": {
        "title": "Enhetsspårning för aktiva minuter och sömn",
        "description": "Din enhet spelar in aktiva minuter under måttlig eller hög intensitet fysisk aktivitet-det är kvalitetsmotion! Använder du en enhet för att spåra din sömn? Du kommer också att tjäna %{points} för det!"
    },
    "hourShort": "tim",
    "hoursShort": "tim",
    "secondsShort": "sek",
    "watchToEarn": "Titta för att tjäna",
    "oneParticipant": "1 deltagare",
    "oneTeam": "1 lag",
    "numberOfTeams": "%{num} lag",
    "inviteToYourTeam": "Bjud in till ditt lag",
    "inviteToThisChallenge": "Bjud in till denna utmaning",
    "challengeInstructionText": "Spåra denna aktivitet för att göra framsteg mot din %{challengeType}.",
    "showLess": "Visa mindre",
    "startsTomorrow": "Börjar imorgon",
    "deadlineDayLeft": "dag kvar",
    "deadlineDaysLeft": "dagar kvar",
    "deviceBonus": "enhetsbonus",
    "appsAndDevices": {
        "header": "Appar och enheter",
        "linked": "Dessa länkade appar och enheter spårar mot denna %{challengeType}:",
        "noLinked": "Inga tillämpliga appar eller enheter länkade",
        "link": "Länka telefonen, klockan eller appen för att spåra automatiskt."
    },
    "yourGoals": "Dina mål",
    "yourChallenges": "Dina utmaningar",
    "position": "Position",
    "team_success": "Lagets framgång",
    "starts_in": "Börjar om",
    "team_challenge": "Lagutmaning",
    "your_progress_today": "Dina framsteg idag",
    "your_daily_avarage": "Ditt dagliga genomsnitt är",
    "this_week_progress": "Denna veckas framsteg",
    "this_month_progress": "Denna månads framsteg",
    "overall_progress": "Övergripande framsteg",
    "complete": "klar",
    "overallSuccess": "Övergripande framgång",
    "teamSuccessAverage": "Lagets genomsnittliga framgång",
    "progressDetails": "Detaljer om framgången",
    "dayStreak": "%{n}-dagars följd!",
    "weekStreak": "%{n}-veckors följd!",
    "dailyProgress": "Dina dagliga framsteg",
    "participantsSuccessCount": {
        "overall": "%{amount} av %{total} deltagare har nått målet",
        "day": "%{amount} av %{total} deltagare har nått målet idag",
        "week": "%{amount} av %{total} deltagare har nått målet denna vecka",
        "month": "%{amount} av %{total} deltagare har nått målet den här månaden"
    },
    "doubleBonusShort": "Dubbel bonus!",
    "doubleBonusLong": "Du har tjänat en dubbel bonus!",
    "recommendedGoalDescription": "Mål hjälper dig att hålla koll på dina framsteg och hålla dig motiverad!",
    "noParticipation": "Inget deltagande",
    "nothingToShow": "Ser ut som det inte finns något att visa just nu",
    "yourTeam": "Ditt lag",
    "no_activity_title": "Ingen aktivitet",
    "brandSupport": {
        "description": "Vi har lagt till stöd för aktivitetssynkronisering med Polar- och Withings-smartklockor. Dags att röra på sig!"
    },
    "no_tracked_activities": "Du har inte spårat några aktiviteter ännu.",
    "button_leave_community": "Lämna community",
    "button_delete_challenge": "Radera %{challengeType}",
    "button_delete_community": "Radera community",
    "button_delete_activity": "Radera aktivitet",
    "library_header_description": "Originalinnehåll finns för att utbilda, engagera och inspirera dig på din välbefinnande-resa.",
    "library_searchbar": "Sök i biblioteket...",
    "library_page_header": "Originalinnehåll finns för att utbilda, engagera och inspirera dig på din välbefinnande-resa.",
    "onboarding_button_title": "Jag är färdig",
    "refresh_bar": "Klicka här för att uppdatera",
    "content": {
        "min_read": "%{readingTime} min läsning"
    },
    "noMembers": "Inga medlemmar",
    "saved": "Sparad",
    "forYou": "För dig",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "%{badgeInstruction} av",
    "youCanEarnThisBadge": "Du kan tjäna detta märke en gång per %{period}",
    "emailPreferences": "Inställningar för e-post",
    "unsubscribeText": "Välj bort alla e-postuppdateringar",
    "savingText": "Sparar...",
    "wrongTryLater": "Någonting gick fel. Vänligen försök igen senare.",
    "preferencesSaved": "Inställningarna sparades",
    "recommendedForYou": "Rekommenderas för dig",
    "formerMember": {
        "label": "Tidigare medlem"
    },
    "selectionsFromLibrary": "Urval från vårt bibliotek som valts just för dig",
    "goalsInfo": {
        "desc1": "att fokusera på att förbättra ditt välbefinnande",
        "desc2": "Du har satt upp det maximala antalet mål."
    },
    "createMyOwn": "Skapa min egen",
    "isAllSet": "är klart!",
    "undoLabel": "Ångra",
    "terms": "Termer",
    "placeOrder": "Slutför köp",
    "item": "Artikel",
    "redeemFor": "Lös in för",
    "confirmYourOrder": "Bekräfta din order",
    "orderComplete": "Beställning klar",
    "redeemedFor": "Inlöst för",
    "orderDetails": "Beställningsuppgifter",
    "bonusGoalReward": "Belöning för bonusmål",
    "orderSummary": "Beställningsöversikt",
    "logoutSSO": {
        "title": "Du har loggat ut från %{programName}.",
        "description": "Vi ses snart igen!",
        "signinAgain": "Klicka här för att logga in igen"
    },
    "nothing_to_show": "Här finns Inget att visa för tillfället",
    "no_saved_content": "Du har inget sparat innehåll",
    "restarts_every_week": "Startar om varje vecka",
    "myGoals": "Mina mål",
    "goalGallery": "Målgalleri",
    "share_smth": "Dela någonting...",
    "newFeatureModal": {
        "smartGoal": {
            "title": "Vårt stegmål blev precis smartare!",
            "description": "Dina veckor är alltid annorlunda – nu är dina mål också det! \nMed Smart Mode kommer ditt stegmål att justera sig självt baserat på din verkliga aktivitet.\nDet är uppsatt med din framgång och välbefinnande i åtanke.",
            "action": "Kolla in det!"
        },
        "mePage": {
            "title": "Mitt nya Jag",
            "description": "Vi har gjort om Jag-sektionen för att göra det enklare att hitta de saker du bryr dig om – kika gärna!",
            "letsSeeBtn": "Då ska vi se!",
            "llaterBtn": "Möjligen senare"
        },
        "bellEAP": {
            "title": "Välkommen till din onlineplattform för EFAP (Employee and Family Assistance Program)",
            "description": "Upptäck de verktyg och tjänster för att stödja välbefinnande och livsutmaningar som är tillgängliga för dig och dina berättigade familjemedlemmar",
            "button": "Anslut nu eller besök snabblänksidan när som helst"
        },
        "quickActivityLogView": {
            "title": " Ett snabbare sätt att se din senaste aktivitet",
            "description": "Du kan nu klicka på förloppsfältet för att se din aktivitetslogg."
        }
    },
    "goalSmartMode": {
        "title": "Smart läge",
        "description": "Få anpassade veckomål baserat på din senaste aktivitetsnivå.",
        "status": "Smart Mode är %{status} för detta mål.",
        "infoModal": {
            "descriptionOne": "När Smart Mode är på kommer ambitionen för detta mål att ändras från vecka till vecka baserat på din senaste aktivitetsnivå.",
            "descriptionTwo": "Vi kommer att utmana dig i precis rätt mängd för att förbereda dig för framgång.",
            "instructions": ""
        },
        "settings": {
            "switch": "Aktivera Smart Mode för mitt stegmål",
            "description": "När Smart Mode är på får du ett nytt stegmål i början av varje vecka."
        },
        "enableSmartMode": "Aktivera Smart Mode",
        "settingsModal": {
            "descriptionTurnOn": "Ditt stegmål ändras varje vecka baserat på din aktivitet",
            "descriptionTurnOff": "Ditt stegmål kommer inte längre att anpassas varje vecka"
        }
    },
    "On": "På",
    "Off": "Av",
    "top_posts": "Översta inläggen",
    "most_recent": "Senaste",
    "browseByTopic": "Bläddra efter ämne",
    "video": "Video",
    "enable": "Aktivera",
    "turnOff": "Slå av",
    "new_post": "Nytt inlägg",
    "new_post_in": "Nytt inlägg i",
    "dailyTarget": "Dagligt mål",
    "dailyTargetForWeek": "Dagligt mål för veckan",
    "showMyActivityLog": "Visa min aktivitetslogg",
    "usersReacted": {
        "oneOther": "%{userName} och 1 annan",
        "multipleOthers": "%{userName} och %{count} andra"
    },
    "reactionsModal": {
        "title": "Fler sätt att fira",
        "description": "Heja på dina kollegor med nya reaktioner på sociala inlägg!"
    },
    "account": "Konto",
    "myWellbeingProfile": "Min välbefinnandeprofil",
    "physicalDetailsDescription": "Denna information behövs för att beräkna dina välbefinnandepoäng",
    "wellbeingInterests": "Intressen inom välbefinnande",
    "myWellbeingInterests": "Mina intressen inom välbefinnande",
    "preferredNameOptional": "Namnpreferens (valfritt)",
    "basicPhysicalDetails": "Grundläggande fysiska uppgifter",
    "notRegistered": {
        "infoModal": {
            "title": "Vi kan inte hitta dig",
            "notInSystem": "finns inte i vårt system.",
            "correctEmail": "Var noga med att använda rätt konto (vanligtvis en företagets e-postadress) och kontrollera för skrivfel.",
            "emailHelp": "Om du vill ha mer hjälp kan du skicka ett e-postmeddelande till vårt supportteam på"
        }
    },
    "dontHaveAccount": "Har du inget konto?",
    "wasThisHelpful": "Var detta användbart?",
    "healthScoreFeedbackModal": {
        "emojiSection": "Hur användbar är den här sidan och dina välbefinnandepoäng?",
        "commentSectionText": "Om nej, på vilka punkter kan de förbättras?",
        "commentSectionPlaceholder": "Lägg till en kommentar...",
        "thankYouModal": "Tack för din feedback!"
    },
    "number_connected": "%{numDevices} ansluten",
    "searchPlaceHolder": "Sök...",
    "noTeamsFound": "Inga team hittade",
    "join_a_challenge": "Gå med i en utmaning",
    "me_page_titles": {
        "goal": {
            "singular": "mål",
            "plural": "mål"
        },
        "challenge": {
            "singular": "utmaning",
            "plural": "utmaningar"
        }
    },
    "seeMoreText": "…läs mer",
    "adjust_entry": "Vänligen justera posten.",
    "overTracking": {
        "title": "Varning för överanvändning",
        "desc1": {
            "singular": "Denna post kommer att granskas.",
            "plural": "Dessa poster kommer att granskas."
        },
        "desc2": "Avsiktlig överanvändning kan leda till avstängning av kontot.",
        "button_edit": "Redigera mina poster",
        "button_confirm": "Skicka som det är"
    },
    "oneEventAttendee": "1 deltagare",
    "multipleEventAttendees": "%{num} deltagare",
    "to": "till",
    "eventBonusFull": "Du kommer att tjäna %{number} bonus %{points} genom att delta i detta evenemang.",
    "eventBonusBold": "%{number} bonus %{points}",
    "didYouLikeArticle": "Tyckte du om den här artikeln?",
    "didYouLikeVideo": "Gillade du den här videon?",
    "tellUsMore": "Berätta mer...",
    "thanksForFeedback": "Tack för din feedback!",
    "challengesSubtitle": "Nå ett mål tillsammans med andra deltagare - eller delta för att vinna!",
    "appStoreNameSprout": "Sprout på jobbet",
    "appStoreNameLiveBetter": "Medibank Live Better",
    "appStoreNameTelus": "TELUS Health Wellbeing",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "Telus Health Virtual Care",
    "virtualCare": "Virtuell vård",
    "changePassword": {
        "telus": {
            "info": "Ditt lösenord hanteras via ditt %{telusVC} -konto.",
            "button": "Byt mitt %{virtualCare}-lösenord"
        }
    },
    "actions": "åtgärder",
    "onAndUpcoming": "On & upcoming",
    "termsAndPrivacyPolicyNew": "Genom att fortsätta godkänner du",
    "invitedToTeam": "Inbjuden till teamet som tillhör %{firstName} %{lastName}",
    "decline": "Avböj",
    "invitedToChallenge": "Inbjuden av %{firstName} %{lastName}",
    "goalsCard": {
        "emptyStateTitle": "Du har inga uppsatta mål"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "Du är inte med i några utmaningar",
        "buttonLabel": "Utforska utmaningar"
    },
    "menu": "Meny",
    "everyone": "Alla",
    "confirmEmployeeID": "Bekräfta anställnings-ID",
    "employeeIDNoMatch": "Dessa ID:n matchar inte ännu",
    "hidePost": "Dölj inlägg efter %{ownerName}",
    "hidingUserPostToast": {
        "success": {
            "title": "Användare dold",
            "message": "Du kommer inte att se inlägg av den här användaren längre."
        }
    },
    "moderateHideUserDescription": "Att dölja inlägg för den här användaren kommer att ta bort användarspecifikt innehåll från strömmen.",
    "startsInOneDay": "Börjar om 1 dag",
    "endsInOneDay": "Slutar om 1 dag",
    "endsToday": "Avslutas idag",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "finns inte i vårt system. Har du angett det korrekt?",
            "administrator": "Om du är en nyanställd kanske vi inte har ditt anställnings-ID ännu. Fråga din administratör om när du ska försöka igen.",
            "emailNotInSystem": "Om du är nyanställd kanske din e-postadress inte har lagts till i vårt system ännu. Fråga din administratör om när du ska försöka igen.",
            "eligibleEmail": "är inte en giltig e-postadress. Har du angett den korrekt?"
        }
    },
    "oneMember": "1 medlem",
    "programCode": {
        "infoModal": {
            "unique": "Ditt företag har en unik programkod som vanligtvis ges till dig i ett e-postmeddelande.",
            "support": "Om du inte hittar din kod kontaktar du administratören för ditt hälsoprogram eller skickar ett e-postmeddelande till support@sproutatwork.com med ditt företagsnamn."
        },
        "instructions": "Ange programkoden från din arbetsgivare för att komma igång"
    },
    "whatsMyProgramCode": "Vad är min programkod?",
    "enjoyApp": "Dra nytta av vår mobilapp",
    "programCodeLabel": "Programkod",
    "createdByMembersChallenges": "Skapad av medlemmar",
    "invites": "Inbjudningar",
    "recommendedContentTitle": "Biblioteksurval för dig",
    "amountExchanged": "Utbytt belopp",
    "orderStatus": "Orderstatus",
    "orderSuccessfulyyItemForConfirmation": "Beställningen lyckades! En bekräftelse har skickats till %{email}.",
    "orderedOnDateText": "Beställd den %{orderCreatedTime}",
    "personalize": {
        "communities": {
            "title": "Gå med i communityn",
            "description": "Communities förenar människor med gemensamma intressen. Du kan när som helst gå med i eller lämna communityn."
        },
        "objectives": {
            "title": "Mina mål",
            "description": "Vad kan vi hjälpa dig att starta eller underhålla? Vi kommer att använda detta för att förbättra våra rekommendationer."
        },
        "topics": {
            "title": "Mina valda ämnen inom välbefinnande",
            "description": "Du kommer att se fler tips och anvisningar om dessa val."
        }
    },
    "recommendedCardDesc": "Ställ in upp till 3 mål för att fokusera på att förbättra ditt välbefinnande",
    "accessibility": {
        "track_activity": "Spåra aktivitet",
        "cardbody": "Kort body",
        "cardcontainer": "Kort container",
        "cardfooter": "Kort footer",
        "unstartedChallengeHeader": "Ej startad utmaning",
        "activeOrEndedChallengeWrapper": "Utmaning wrapper",
        "activeOrEndedChallengeHeader": "Utmaning header",
        "goalHeader": "Mål header",
        "openOptions": "Öppna Alternativ"
    },
    "teams": {
        "teamInvites": "Teaminbjudningar",
        "findTeam": "Hitta ett team",
        "teamFull": "Teamet är fullt"
    },
    "deleteAccountText": "Ta bort ditt Sprout At Work-konto och alla dess data permanent",
    "deleteAccountButtonTitle": "Radera mitt konto",
    "joinTeamActionSheetText": "Gå med eller skapa ett team för att delta i denna utmaning",
    "frequencyNone": "inga",
    "quickLinkTitle": "Snabblänkar",
    "moreTab": "Mer",
    "addedBy": "Tillagd av %{companyName}",
    "teamsTitle": "Team",
    "helpAndSupport": "Hjälp och support för appen",
    "feedbackTitle": "Ge feedback",
    "feedbackDescription": "Berätta vad du gillar med appen och var vi kan förbättra oss.",
    "leaveTeamAction": "Lämna teamet",
    "teamActions": "Teamåtgärder",
    "leaveTeamLeaveChallenge": "Att lämna detta team innebär att du lämnar utmaningen. Du måste gå med i ett team för att fortsätta delta.",
    "familyMembers": "Familjemedlemmar",
    "familyMembersDescription": "Familjemedlemmar måste vara över 16 år. De kommer att ha full åtkomst och synlighet över hela plattformen.",
    "learnMoreButton": "Läs mer",
    "thvcSelection": {
        "signUpUsingTelus": "Registrera dig med ditt Telus Health Virtual Care-konto",
        "loginGetStarted": "Logga in på Virtual Care för att komma igång",
        "haveAccount": "Har du ett Virtual Care-konto?",
        "emailHelp": "Behöver du hjälp? Kontakta vårt supportteam på",
        "yes": "Ja",
        "signMeUp": "Nej, registrera mig"
    },
    "inviteFamilyMember": {
        "label": "Bjud in familjemedlem",
        "btn": "Skicka inbjudan",
        "email": "E-postadress*",
        "firstName": "Förnamn*",
        "lastName": "Efternamn*",
        "approval": "Jag bekräftar att jag har godkännande att bjuda in denna familjemedlem till %{company}",
        "multiSelect1": "Är denna familjemedlem myndig i din region?",
        "multiSelect2": "Är denna familjemedlem minst 16 år gammal?",
        "confirmTermsPolicy": "Jag bekräftar att jag är den här personens vårdnadshavare. Enligt min bedömning är den omyndige tillräckligt mogen för att samtycka till användningen av plattformen, och jag samtycker till att de ansluter sig till den. Jag kommer att förklara för den omyndige om behovet av ansvarsfullt beteende på plattformen och hur plattformen samlar in och använder deras data.",
        "onTheirBehalf": "för deras räkning.",
        "confirm": "Ja, jag bekräftar ovanstående",
        "warning": "Familjemedlem måste vara minst 16 år för att registrera sig",
        "errorMsg": "Vänligen granska fel innan du försöker fortsätta"
    },
    "deleteFamilyMember": {
        "desc": "Att radera en familjemedlems konto är permanent.",
        "btn": "Radera familjemedlem",
        "confirmation": {
            "title": "Familjemedlem raderad",
            "desc": "{fullName}s konto raderades"
        },
        "areYouSure": "Är du säker på att du vill radera %{fullName} konto?"
    },
    "familyInvitationStatus": {
        "active": "Aktiv",
        "sent": "Inbjudan skickad"
    },
    "familyInvitationSent": {
        "title": "E-postinbjudan skickad",
        "desc": "Inbjudan skickad till %{fullName}"
    },
    "programCodeSignup": "Använd %{programCodeLabel} %{programCode} efter att ha klickat på '%{signUpLabel}'",
    "notJoinedCommunityLabel": "Gå med i denna community för att se vad medlemmarna delar",
    "moda": {
        "installApp": {
            "title": "Vänligen notera: Moda Health-medlemmar kan endast komma åt Sprout at Work via deras medlemspanel.",
            "subtitle": "Så här använder du Sprout at Work på din smartphone:",
            "stepOneA": "1. Installera mobilappen Sprout at Work.",
            "stepOneB": "Registrera dig eller logga inte in på mobilappen.",
            "stepTwo": "2. Logga in på din Member Dashboard på din mobiltelefon",
            "stepThree": "3. Bläddra till Sprout-hälsoprogrammet och följ den länken – den bör öppna mobilappen Sprout at Work."
        }
    },
    "HRISLocationSelection": {
        "title": "Vilket land jobbar du från?"
    },
    "visibilitySettings": {
        "title": "Synlighetsinställningar",
        "desc1": "Är det okej att vara synlig för andra Wellbeing-appmedlemmar i ditt företag?",
        "desc2": "Du kan alltid ändra detta senare.",
        "moreTextQ1": "Vad kan andra människor se?",
        "moreTextAnswer1": "Ditt namn, profilfoto och grundläggande profildetaljer (som avdelning och plats) kan ses av personer i ditt företag. Detta gör appen mer social och rolig.",
        "moreTextQ2": "Var visas jag?",
        "moreTextAnswer2": "Du kommer att visas som deltagare för utmaningar, gemenskaper och evenemang du går med i, i topplistor och i sökresultat. Du kan justera detta senare.",
        "moreTextAnswer3": "Vi delar eller visar inte din personliga hälsoinformation, som din längd, vikt eller aktiviteten du spårar.",
        "btnAgree": "Det är okej att visa mig",
        "btnDisagree": "Låt inte andra medlemmar se mig"
    },
    "privacyPolicyReadMore": "För att lära dig mer, läs vår sekretesspolicy",
    "tellMeMore": "Berätta mer",
    "helpUsImprove": {
        "title": "Hjälp oss att förbättra",
        "desc1": "Vi använder verktyg som registrerar anonym användningsdata. Att se trender i vad människor ser och klickar på hjälper oss att göra appen bättre.",
        "desc2": "Du kan stänga av detta när som helst.",
        "moreTextQ1": "Vad vi tittar på",
        "moreTextAnswer1": "Vi är intresserade av övergripande trender och statistik, så vi tittar inte på data på individnivå.",
        "moreTextQ2": "Vi delar inte dina uppgifter",
        "moreTextAnswer2": "Denna information är endast tillgänglig för personerna som bygger den här appen för att göra den bättre. Vi delar det inte med andra företag, inklusive din arbetsgivare.",
        "moreTextQ3": "Dina uppgifter är anonyma",
        "moreTextAnswer3": "Våra verktyg registrerar inte ditt namn, exakta plats eller någon personlig hälsoinformation.",
        "btnAgree": "Spåra min användning anonymt",
        "btnDisagree": "Jag samtycker inte till spårning"
    },
    "deleteAccountTextAppName": "Ta bort ditt %{appName}-konto och all dess data permanent",
    "anonymousMember": "Anonym medlem",
    "activitiesToTrack": {
        "title": "Aktiviteter att spåra"
    },
    "includedInMembership": "Ingår i ditt medlemskap",
    "invalidDate": "Ogiltigt datum",
    "discardsStreamPost": {
        "discardTitle": "Släng inlägget?",
        "discardChangesTitle": "Vill du ignorera ändringar?",
        "discardPostText": "Är du säker på att du vill slänga ditt inlägg?",
        "discardPostChangesText": "Är du säker på att du vill ignorera dina ändringar?"
    },
    "trackActivityModalTitle": "Spår för %{date}",
    "noPosts": "Inga inlägg att se",
    "goalIcon": "Målikon",
    "resetsOn": "Återställs %{date}",
    "clickForHelp": "Klicka här för hjälp",
    "trackActivityInputLabel": "Ange %{unit} %{activityName} %{dateFormat}",
    "itemsFound": "Objekt hittades",
    "tagState": {
        "active": "Aktiv",
        "notActive": "Inte aktiv"
    },
    "bonusCheckmarkLabel": "Fick %{bonusLabel} bonuspoäng för slutförande",
    "searchBar": {
        "searching": "söker %{term}",
        "result": "sökresultat"
    },
    "activityProgress": "Aktivitetsförlopp - %{levelName} %{percentFilled}% - Återställs om %{daysLeft} dagar",
    "bookmark": {
        "remove": "Ta bort från sparade objekt",
        "save": "Spara denna artikel"
    },
    "bonusMark": {
        "earn": "Tjäna %{qty} %{points}",
        "earned": "Du tjänade %{qty} %{points}"
    },
    "tabToTrackActivity": "Tryck för att spåra aktivitet",
    "videoElementLabel": "%{title}, varaktighet %{duration}, Dubbeltryck för att spela upp video",
    "updatedPoliciesPopup": {
        "title": "Vi har uppdaterat våra villkor",
        "details": "Vi uppmuntrar dig att läsa våra uppdaterade policyer nedan:",
        "disclaimer": "Genom att klicka på knappen nedan godkänner och accepterar du de uppdaterade policyerna.",
        "agree": "Jag håller med"
    },
    "editActivityLog": {
        "canNotEditItem": "Du kan inte redigera denna post",
        "canNotEditItemDescription": "Redigering är inte tillgängligt för aktiviteter som synkroniseras från enheter eller appar.",
        "updatedItem": "Aktiviteten uppdaterad",
        "updatedItemDescription": "Dina ändringar har sparats."
    },
    "login_with_email": "Logga in med e-post",
    "healthconnect_not_available": "Det går inte att ansluta till Health Connect. Se till att behörigheter är aktiverade i Health Connect-appen.",
    "registrationField": {
        "required": {
            "firstName": "Vänligen ange ditt förnamn",
            "lastName": "Vänligen ange ditt efternamn",
            "email": "Vänligen ange en giltig e-postadress",
            "password": "Vänligen ange ett giltigt lösenord"
        }
    },
    "settingsErrorMessage": {
        "firstName": "Vänligen ange ditt förnamn",
        "lastName": "Vänligen ange ditt efternamn"
    },
    "requiredValidValue": "Ange ett giltigt värde för din %{value}",
    "passwordHidden": "Lösenordet är dolt, tryck för att visa lösenordet",
    "passwordShown": "Lösenordet visas, tryck för att dölja lösenordet",
    "libraryHeaderContent": {
        "category": "",
        "points": "Tjäna %{points} poäng."
    },
    "scoreCurrentPeriod": "%{text} är från %{startDate} till %{endDate}",
    "scoreCurrent": "%{text} är %{points} poäng",
    "abbotResetPasswordModal": {
        "title": "Försöker du komma åt ett konto från förra året?",
        "text": " Om du registrerade dig för förra årets utmaning kommer det kontot inte att fungera längre. Du måste anmäla dig för i år.",
        "goToResetPasswordBtn": "Jag registrerade mig i %{currentYear}",
        "goToSignupBtn": "Jag har inte registrerat mig i %{currentYear}"
    },
    "challengeRegistrationClosed": "Anmälan stängd - Utmaningen har startat"
};